// Path: ./src/locales/messages.ts
/**
 * This file is only need if you want to extract messages into JSON files in locales folder
 * AND if you are also using the object syntax instead of string syntax. \
 * Check the documentation section i18n for details
 */
import { translations } from "./translations";
import { _t } from "../utils/messages";

export const messages = {
  Notifications: () => _t(translations.Notifications),
  Closed: () => _t(translations.Closed),
  Open: () => _t(translations.Open),
  Distance: () => _t(translations.Distance),
  Google_Reviews: () => _t(translations.Google_Reviews),
  mi: () => _t(translations.mi),
  km: () => _t(translations.km),
  Add_To_Shopping_List: () => _t(translations.Add_To_Shopping_List),
  On_Google_Maps: () => _t(translations.On_Google_Maps),
  View_All_Deals: () => _t(translations.View_All_Deals),
  Weekly_Flyer: () => _t(translations.Weekly_Flyer),
  Search: () => _t(translations.Search),
  Dont_Miss_Out: () => _t(translations.Dont_Miss_Out),
  Your_Shopping_List_Is_Empty: () =>
    _t(translations.Your_Shopping_List_Is_Empty),
  Add_deals_to_it_redeem_them_in_store: () =>
    _t(translations.Add_deals_to_it_redeem_them_in_store),
  Spots_Left: () => _t(translations.Spots_Left),
  Get_Exclusive_Deals: () => _t(translations.Get_Exclusive_Deals),
  Receive_the_best_promotions_available_right_within_your_SMS_inbox: () =>
    _t(
      translations.Receive_the_best_promotions_available_right_within_your_SMS_inbox,
    ),
  Phone_Number: () => _t(translations.Phone_Number),
  Notification_Emails: () => _t(translations.Notification_Emails),
  Add_Email: () => _t(translations.Add_Email),
  Email: () => _t(translations.Email),
  EmailAlreadyAdded: () => _t(translations.EmailAlreadyAdded),
  NotificationEmailsTooltip: () => _t(translations.NotificationEmailsTooltip),
  Logout: () => _t(translations.Logout),
  Name: () => _t(translations.Name),
  Subscribe: () => _t(translations.Subscribe),
  Thanks_for_subscribing: () => _t(translations.Thanks_for_subscribing),
  Deals_Available: () => _t(translations.Deals_Available),
  Deals: () => _t(translations.Deals),
  Stores: () => _t(translations.Stores),
  Shopping_List: () => _t(translations.Shopping_List),
  Favorites: () => _t(translations.Favorites),
  Explore: () => _t(translations.Explore),
  Best_Deals: () => _t(translations.Best_Deals),
  Closest: () => _t(translations.Closest),
  Day_Left: () => _t(translations.Day_Left),
  Expire_Today: () => _t(translations.Expire_Today),
  Save: () => _t(translations.Save),
  Back: () => _t(translations.Back),
  View: () => _t(translations.View),
  Review: () => _t(translations.Review),
  Deals_From_Same_Store: () => _t(translations.Deals_From_Same_Store),
  Absolutely_Loving_The_App: () => _t(translations.Absolutely_Loving_The_App),
  Good_But_Could_Be_Improved: () => _t(translations.Good_But_Could_Be_Improved),
  Some_Issues_Id_Like_To_Talk_About: () =>
    _t(translations.Some_Issues_Id_Like_To_Talk_About),
  Not_Really_Good: () => _t(translations.Not_Really_Good),
  Submit_Feedback: () => _t(translations.Submit_Feedback),
  FEEDBACK: () => _t(translations.FEEDBACK),
  How_is_your_experience_so_far: () =>
    _t(translations.How_is_your_experience_so_far),
  Thanks_for_your_feedback: () => _t(translations.Thanks_for_your_feedback),
  Submit: () => _t(translations.Submit),
  Tell_us_why: () => _t(translations.Tell_us_why),
  Redeem_go_to_store: () => _t(translations.Redeem_go_to_store),
  In_shopping_list: () => _t(translations.In_shopping_list),
  Starts_Tomorrow: () => _t(translations.Starts_Tomorrow),
  Banner_Text: () => _t(translations.Banner_Text),
  Contact_Store: () => _t(translations.Contact_Store),
  Call_Us: () => _t(translations.Call_Us),
  Stay_Tuned: () => _t(translations.Stay_Tuned),
  Get_App: () => _t(translations.Get_App),
  Recent_Searches: () => _t(translations.Recent_Searches),
  Trending_Searches: () => _t(translations.Trending_Searches),
  restaurant: () => _t(translations.restaurant),
  All_Flyers: () => _t(translations.All_Flyers),
  Flyers: () => _t(translations.Flyers),
  Favourites: () => _t(translations.Favourites),
  grocery: () => _t(translations.grocery),
  chinesesupermarket: () => _t(translations.chinesesupermarket),
  electricalAppliances: () => _t(translations.electricalAppliances),
  About_Us: () => _t(translations.About_Us),
  Mobile_App: () => _t(translations.Mobile_App),
  FAQ_Help: () => _t(translations.FAQ_Help),
  Give_Some_Feedback: () => _t(translations.Give_Some_Feedback),
  Terms_of_Use: () => _t(translations.Terms_of_Use),
  Privacy_Policy: () => _t(translations.Privacy_Policy),
  Flyer_Deals: () => _t(translations.Flyer_Deals),
  Reviews: () => _t(translations.Reviews),
  InfoStores: () => _t(translations.InfoStores),
  Mobile: () => _t(translations.Mobile),
  Start_Saving_Today: () => _t(translations.Start_Saving_Today),
  Start_Saving: () => _t(translations.Start_Saving),
  Info_TopContent_Title: () => _t(translations.Info_TopContent_Title),
  Info_TopContent_Subtitle: () => _t(translations.Info_TopContent_Subtitle),
  Info_ContentOne_Title: () => _t(translations.Info_ContentOne_Title),
  Info_ContentOne_Subtitle: () => _t(translations.Info_ContentOne_Subtitle),
  Check_Out_The_latest_Flyers: () =>
    _t(translations.Check_Out_The_latest_Flyers),
  Info_ContentTwo_Title: () => _t(translations.Info_ContentTwo_Title),
  Info_ContentTwo_Subtitle: () => _t(translations.Info_ContentTwo_Subtitle),
  Browse_Exclusive_Deals: () => _t(translations.Browse_Exclusive_Deals),
  Info_ContentThree_Title: () => _t(translations.Info_ContentThree_Title),
  Info_ContentThree_Subtitle: () => _t(translations.Info_ContentThree_Subtitle),
  See_Available_Stores: () => _t(translations.See_Available_Stores),
  Info_ContentFourth_Title: () => _t(translations.Info_ContentFourth_Title),
  Info_ContentFourth_Subtitle: () =>
    _t(translations.Info_ContentFourth_Subtitle),
  Start_Browsing_Deals: () => _t(translations.Start_Browsing_Deals),
  SEE_WHAT_OTHERS_HAVE_TO_SAY: () =>
    _t(translations.SEE_WHAT_OTHERS_HAVE_TO_SAY),
  I_simply_cant_shop_without_the_GoFlyer_app_anymore: () =>
    _t(translations.I_simply_cant_shop_without_the_GoFlyer_app_anymore),
  My_wife_calculated_that_weve_saved_34550_so_far: () =>
    _t(translations.My_wife_calculated_that_weve_saved_34550_so_far),
  The_app_made_me_discover_my_new_goto_stores: () =>
    _t(translations.The_app_made_me_discover_my_new_goto_stores),
  Downtown_Toronto: () => _t(translations.Downtown_Toronto),
  North_York: () => _t(translations.North_York),
  Etobicoke: () => _t(translations.Etobicoke),
  BROWSE_GoFlyer_START_SAVING_NOW: () =>
    _t(translations.BROWSE_GoFlyer_START_SAVING_NOW),
  On_Your_iPhone: () => _t(translations.On_Your_iPhone),
  On_Your_Computer: () => _t(translations.On_Your_Computer),
  On_Your_Android_Phone: () => _t(translations.On_Your_Android_Phone),
  Have_any_questions: () => _t(translations.Have_any_questions),
  Contact_Us: () => _t(translations.Contact_Us),
  Who_we_are: () => _t(translations.Who_we_are),
  Products: () => _t(translations.Products),
  Mobile_APP: () => _t(translations.Mobile_APP),
  Legal: () => _t(translations.Legal),
  Careers: () => _t(translations.Careers),
  All_rights_reserved: () => _t(translations.All_rights_reserved),
  Sign_In: () => _t(translations.Sign_In),
  Sign_Up: () => _t(translations.Sign_Up),
  Profile: () => _t(translations.Profile),
  Featured: () => _t(translations.Featured),
  Latest: () => _t(translations.Latest),
  Grocery: () => _t(translations.Grocery),
  Original_Price: () => _t(translations.Original_Price),
  Store_Price: () => _t(translations.Store_Price),
  Matchup_At: () => _t(translations.Matchup_At),
  Favorite_Empty_Title: () => _t(translations.Favorite_Empty_Title),
  Favorite_Empty_Click: () => _t(translations.Favorite_Empty_Click),
  Favorite_Empty_Description1: () =>
    _t(translations.Favorite_Empty_Description1),
  Favorite_Empty_Description2: () =>
    _t(translations.Favorite_Empty_Description2),
  Favorite_Empty_Button: () => _t(translations.Favorite_Empty_Button),
  Download_Goflyer: () => _t(translations.Download_Goflyer),
  Download_Goflyer_Description1: () =>
    _t(translations.Download_Goflyer_Description1),
  Download_Goflyer_Description2: () =>
    _t(translations.Download_Goflyer_Description2),
  Valid: () => _t(translations.Valid),
  See_More_Product: () => _t(translations.See_More_Product),
  Merchants: () => _t(translations.Merchants),
  Search_Flyers_or_Items: () => _t(translations.Search_Flyers_or_Items),
  Items: () => _t(translations.Items),
  UpComing: () => _t(translations.UpComing),
  Click_To_See_Flyer: () => _t(translations.Click_To_See_Flyer),
  THERE_ARE_NO_UPCOMING_FLYER_STAY_TUNED: () =>
    _t(translations.THERE_ARE_NO_UPCOMING_FLYER_STAY_TUNED),
  CLICK_TO_SEE_MORE_FLYERS: () => _t(translations.CLICK_TO_SEE_MORE_FLYERS),
  Starting_On: () => _t(translations.Starting_On),
  Create_FLyer: () => _t(translations.Create_FLyer),
  Create_Deals: () => _t(translations.Create_Deals),
  Create_Coupon: () => _t(translations.Create_Coupon),
  Upload_Flyer: () => _t(translations.Upload_Flyer),
  Upload_Menu: () => _t(translations.Upload_Menu),
  Product_Name: () => _t(translations.Product_Name),
  Second_Language: () => _t(translations.Second_Language),
  French: () => _t(translations.French),
  Third_Language: () => _t(translations.Third_Language),
  Category: () => _t(translations.Category),
  Promotion_Tag: () => _t(translations.Promotion_Tag),
  Sale_Price: () => _t(translations.Sale_Price),
  Reg_Price: () => _t(translations.Reg_Price),
  Quantity: () => _t(translations.Quantity),
  Unit: () => _t(translations.Unit),
  Product_Images: () => _t(translations.Product_Images),
  Done: () => _t(translations.Done),
  Save_Product: () => _t(translations.Save_Product),
  Overview: () => _t(translations.Overview),
  Add_Deal: () => _t(translations.Add_Deal),
  Saved_Product: () => _t(translations.Saved_Product),
  Date: () => _t(translations.Date),
  Size: () => _t(translations.Size),
  Total: () => _t(translations.Total),
  Statistics_Summary_Description: () =>
    _t(translations.Statistics_Summary_Description),
  Statistics_Categories_Description: () =>
    _t(translations.Statistics_Categories_Description),
  Format: () => _t(translations.Format),
  Start_Date: () => _t(translations.Start_Date),
  Publish_Date_and_Time: () => _t(translations.Publish_Date_and_Time),
  Publish_Date_and_Time_Tooltip: () =>
    _t(translations.Publish_Date_and_Time_Tooltip),
  Filters: () => _t(translations.Filters),
  Product_Description: () => _t(translations.Product_Description),
  First_Language: () => _t(translations.First_Language),
  Regular_Price: () => _t(translations.Regular_Price),
  Price_Remarks: () => _t(translations.Price_Remarks),
  Limit: () => _t(translations.Limit),
  Front_Page: () => _t(translations.Front_Page),
  No_Category: () => _t(translations.No_Category),
  Both: () => _t(translations.Both),
  Category_Tooltip_Total: () => _t(translations.Category_Tooltip_Total),
  Category_Tooltip_With_Front: () =>
    _t(translations.Category_Tooltip_With_Front),
  Change_Image: () => _t(translations.Change_Image),
  Local_Upload: () => _t(translations.Local_Upload),
  Sync_Update_to: () => _t(translations.Sync_Update_to),
  Accounts: () => _t(translations.Accounts),
  User: () => _t(translations.User),
  Role: () => _t(translations.Role),
  Permission: () => _t(translations.Permission),
  Tags: () => _t(translations.Tags),
  Store_Tag: () => _t(translations.Store_Tag),
  Flyer_Tag: () => _t(translations.Flyer_Tag),
  Menu_Tag: () => _t(translations.Menu_Tag),
  Create: () => _t(translations.Create),
  Delete: () => _t(translations.Delete),
  Edit: () => _t(translations.Edit),
  Name_of_the_New_Role: () => _t(translations.Name_of_the_New_Role),
  Coupon: () => _t(translations.Coupon),
  Permission_Groups: () => _t(translations.Permission_Groups),
  Flyer: () => _t(translations.Flyer),
  Upload: () => _t(translations.Upload),
  Menu: () => _t(translations.Menu),
  Departments: () => _t(translations.Departments),
  Tag: () => _t(translations.Tag),
  Management: () => _t(translations.Management),
  Previous_Deal: () => _t(translations.Previous_Deal),
  Delete_Confirmation: () => _t(translations.Delete_Confirmation),
  Are_you_sure_you_want_to_delete_This: () =>
    _t(translations.Are_you_sure_you_want_to_delete_This),
  Attached_User_Will_Lose_This_Role: () =>
    _t(translations.Attached_User_Will_Lose_This_Role),
  This_action_cannot_be_undone: () =>
    _t(translations.This_action_cannot_be_undone),
  Image_soft_delete_notice: () => _t(translations.Image_soft_delete_notice),
  Deleted: () => _t(translations.Deleted),
  Users_Attached_to_this_role: () =>
    _t(translations.Users_Attached_to_this_role),
  No_User_is_Attached: () => _t(translations.No_User_is_Attached),
  UserName: () => _t(translations.UserName),
  User_Deleted_SuccessFully: () => _t(translations.User_Deleted_SuccessFully),
  Role_Deleted_SuccessFully: () => _t(translations.Role_Deleted_SuccessFully),
  Deleted_SuccessFully: () => _t(translations.Deleted_SuccessFully),
  Error_occurred_while_deleting: () =>
    _t(translations.Error_occurred_while_deleting),
  Cancel: () => _t(translations.Cancel),
  Confirm: () => _t(translations.Confirm),
  Setup: () => _t(translations.Setup),
  Merchant: () => _t(translations.Merchant),
  Select_Flyer_or_Drop_Flyer_Here: () =>
    _t(translations.Select_Flyer_or_Drop_Flyer_Here),
  Select_Image: () => _t(translations.Select_Image),
  Add_Role: () => _t(translations.Add_Role), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) use combination
  Add_User: () => _t(translations.Add_User), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) use combination
  //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) we already have a Create below, use use a combination of Create and Store
  User_Name: () => _t(translations.User_Name),
  required: () => _t(translations.required),
  First_Name: () => _t(translations.First_Name),
  Last_Name: () => _t(translations.Last_Name),
  Password: () => _t(translations.Password),
  Finish: () => _t(translations.Finish),
  Successfully_Updated_Deal: () => _t(translations.Successfully_Updated_Deal),
  Flyer_Uploaded_Successfully: () =>
    _t(translations.Flyer_Uploaded_Successfully),
  Successfully_Deleted_Flyers: () =>
    _t(translations.Successfully_Deleted_Flyers),
  Successfully_Deleted: () => _t(translations.Successfully_Deleted),
  Deal_Added_Successfully: () => _t(translations.Deal_Added_Successfully),
  There_is_an_error_please_Contact_Administrator: () =>
    _t(translations.There_is_an_error_please_Contact_Administrator),
  Deal_Successfully_Deleted: () => _t(translations.Deal_Successfully_Deleted),
  Flyer_Image_missing_please_add_Flyer_Image: () =>
    _t(translations.Flyer_Image_missing_please_add_Flyer_Image),
  missing_please_type: () => _t(translations.missing_please_type),
  missing_please_select: () => _t(translations.missing_please_select),
  Product_Image_missing_please_add_Product_Image: () =>
    _t(translations.Product_Image_missing_please_add_Product_Image),
  PromotionTag: () => _t(translations.PromotionTag),
  Space_is_not_allowed_please_type_without_space: () =>
    _t(translations.Space_is_not_allowed_please_type_without_space),
  Confirm_Password_DoesNot_match_Password: () =>
    _t(translations.Confirm_Password_DoesNot_match_Password),
  Incorrect_Email_please_type_correct_email: () =>
    _t(translations.Incorrect_Email_please_type_correct_email),
  User_Successfully: () => _t(translations.User_Successfully),
  please_select_type_something: () =>
    _t(translations.please_select_type_something),
  is_Empty: () => _t(translations.is_Empty),
  Click_one_of_the_above_and_get_to_continue: () =>
    _t(translations.Click_one_of_the_above_and_get_to_continue),
  What_do_you_want_to_do: () => _t(translations.What_do_you_want_to_do),
  Updated: () => _t(translations.Updated),
  Created: () => _t(translations.Created),
  End_Date: () => _t(translations.End_Date),
  SignOut: () => _t(translations.SignOut),
  Flyer_Successfully: () => _t(translations.Flyer_Successfully),
  Drag_your_image_here: () => _t(translations.Drag_your_image_here),
  or_click_to_browse: () => _t(translations.or_click_to_browse),
  No_images_added_yet: () => _t(translations.No_images_added_yet),
  Are_you_sure_you_want_to_delete_These: () =>
    _t(translations.Are_you_sure_you_want_to_delete_These),
  Update: () => _t(translations.Update),
  Generate_Coordinates: () => _t(translations.Generate_Coordinates),
  Generate_Coordinates_Description: () =>
    _t(translations.Generate_Coordinates_Description),
  Retry_Coordinates: () => _t(translations.Retry_Coordinates),
  Retry_Coordinates_Title: () => _t(translations.Retry_Coordinates_Title),
  Retry_Coordinates_Description: () =>
    _t(translations.Retry_Coordinates_Description),
  Retry_Coordinates_Date_Range: () =>
    _t(translations.Retry_Coordinates_Date_Range),
  Retry_Coordinates_Image_Count: () =>
    _t(translations.Retry_Coordinates_Image_Count),
  Retry_Tile_Job: () => _t(translations.Retry_Tile_Job),
  Retry_Tile_Job_Title: () => _t(translations.Retry_Tile_Job_Title),
  Retry_Tile_Job_Description: () => _t(translations.Retry_Tile_Job_Description),
  Tile_Job_Status: () => _t(translations.Tile_Job_Status),
  Retry_Image_Coordinates_Title: () =>
    _t(translations.Retry_Image_Coordinates_Title),
  Retry_Image_Coordinates_Description: () =>
    _t(translations.Retry_Image_Coordinates_Description),
  Retry_Image_Coordinates_BulletIntro: () =>
    _t(translations.Retry_Image_Coordinates_BulletIntro),
  Retry_Image_Coordinates_BulletTime: () =>
    _t(translations.Retry_Image_Coordinates_BulletTime),
  Retry_Image_Coordinates_BulletOverwrite: () =>
    _t(translations.Retry_Image_Coordinates_BulletOverwrite),
  Retry_Image_Coordinates_Warning: () =>
    _t(translations.Retry_Image_Coordinates_Warning),
  Coordinate_Job_In_Progress_Title: () =>
    _t(translations.Coordinate_Job_In_Progress_Title),
  Coordinate_Job_In_Progress_Description: () =>
    _t(translations.Coordinate_Job_In_Progress_Description),
  Coordinate_Job_In_Progress_Warning: () =>
    _t(translations.Coordinate_Job_In_Progress_Warning),
  Loading_job_status: () => _t(translations.Loading_job_status),
  Flyer_Generation_Estimated_time_remaining: () =>
    _t(translations.Flyer_Generation_Estimated_time_remaining),
  Flyer_Generation_Estimated_time: () =>
    _t(translations.Flyer_Generation_Estimated_time),
  Flyer_Generation_Final_stages_verifying_completion_status: () =>
    _t(translations.Flyer_Generation_Final_stages_verifying_completion_status),
  Server_is_busy_please_wait: () => _t(translations.Server_is_busy_please_wait),
  Flyer_Generated_Successfully_Download_Flyers: () =>
    _t(translations.Flyer_Generated_Successfully_Download_Flyers),
  Flyer_generation_failed_Please_try_again: () =>
    _t(translations.Flyer_generation_failed_Please_try_again),
  Job_Cancelled_Successfully: () => _t(translations.Job_Cancelled_Successfully),
  No_job_ID_available_to_cancel: () =>
    _t(translations.No_job_ID_available_to_cancel),
  Failed_to_cancel_job_Please_try_again: () =>
    _t(translations.Failed_to_cancel_job_Please_try_again),
  Cancelling: () => _t(translations.Cancelling),
  Cancel_Job_Title: () => _t(translations.Cancel_Job_Title),
  Cancel_Job_Description: () => _t(translations.Cancel_Job_Description),
  Cancel_Job_WarningMessage: () => _t(translations.Cancel_Job_WarningMessage),
  AI_Coordination_Mode: () => _t(translations.AI_Coordination_Mode),
  Smart_Flyer_Model: () => _t(translations.Smart_Flyer_Model),
  Use_System_Default: () => _t(translations.Use_System_Default),
  AI: () => _t(translations.AI),
  AI_REFINEMENT: () => _t(translations.AI_REFINEMENT),
  Off: () => _t(translations.Off),
  Merchant_Basics: () => _t(translations.Merchant_Basics),
  Merchant_Basics_Description: () =>
    _t(translations.Merchant_Basics_Description),
  AI_Extraction_Coordination: () => _t(translations.AI_Extraction_Coordination),
  AI_Extraction_Coordination_Description: () =>
    _t(translations.AI_Extraction_Coordination_Description),
  Smart_Flyer_Main_Extraction_System_Prompt_Override: () =>
    _t(translations.Smart_Flyer_Main_Extraction_System_Prompt_Override),
  Smart_Flyer_Main_Extraction_User_Prompt_Override: () =>
    _t(translations.Smart_Flyer_Main_Extraction_User_Prompt_Override),
  SEO_Settings: () => _t(translations.SEO_Settings),
  SEO_Settings_Description: () => _t(translations.SEO_Settings_Description),
  English_SEO: () => _t(translations.English_SEO),
  Chinese_SEO: () => _t(translations.Chinese_SEO),
  French_SEO: () => _t(translations.French_SEO),
  Logos_Branding: () => _t(translations.Logos_Branding),
  Logos_Branding_Description: () => _t(translations.Logos_Branding_Description),
  Optional_System_Prompt_Override: () =>
    _t(translations.Optional_System_Prompt_Override),
  Optional_User_Prompt_Override: () =>
    _t(translations.Optional_User_Prompt_Override),
  Main_Logo: () => _t(translations.Main_Logo),
  Small_Logo: () => _t(translations.Small_Logo),
  Large_Logo: () => _t(translations.Large_Logo),
  Selected_Flyers: () => _t(translations.Selected_Flyers),
  Selected_Flyer_Items: () => _t(translations.Selected_Flyer_Items),
  Selected_Menus: () => _t(translations.Selected_Menus),
  Selected_Units: () => _t(translations.Selected_Units),
  Selected_Stores: () => _t(translations.Selected_Stores),
  Selected_Items: () => _t(translations.Selected_Items),
  Selected_Merchants: () => _t(translations.Selected_Merchants),
  Selected_Images: () => _t(translations.Selected_Images),
  Selected_Templates: () => _t(translations.Selected_Templates),
  Selected_Flyers_Item_Lists: () => _t(translations.Selected_Flyers_Item_Lists),
  Rows_PerPage: () => _t(translations.Rows_PerPage),
  Cant_search_anything_because_you_haveNot_typed_anything: () =>
    _t(translations.Cant_search_anything_because_you_haveNot_typed_anything),
  Please_type_something: () => _t(translations.Please_type_something),
  Rank: () => _t(translations.Rank),
  Goflyer_website_APP: () => _t(translations.Goflyer_website_APP),
  Store_website_APP: () => _t(translations.Store_website_APP),
  Sync_Update: () => _t(translations.Sync_Update),
  salePrice: () => _t(translations.salePrice),
  regularPrice: () => _t(translations.regularPrice),
  unit: () => _t(translations.unit),
  name: () => _t(translations.name),
  nameChinese: () => _t(translations.nameChinese),
  domain: () => _t(translations.domain),
  logo: () => _t(translations.logo),
  smallLogo: () => _t(translations.smallLogo),
  largeLogo: () => _t(translations.largeLogo),
  priceRemarks: () => _t(translations.priceRemarks),
  topSale: () => _t(translations.topSale),
  validStartDate: () => _t(translations.validStartDate),
  limitQuantityPerFamily: () => _t(translations.limitQuantityPerFamily),
  updatedAt: () => _t(translations.updatedAt),
  gfImages: () => _t(translations.gfImages),
  promotionTag: () => _t(translations.promotionTag),
  gfFlyerItemCategory: () => _t(translations.gfFlyerItemCategory),
  validEndDate: () => _t(translations.validEndDate),
  createdAt: () => _t(translations.createdAt),
  pdf: () => _t(translations.pdf),
  rank: () => _t(translations.rank),
  merchant: () => _t(translations.merchant),
  flyerTag: () => _t(translations.flyerTag),
  edit: () => _t(translations.edit),
  id: () => _t(translations.id),
  delete: () => _t(translations.delete),
  userName: () => _t(translations.userName),
  longitude: () => _t(translations.longitude),
  latitude: () => _t(translations.latitude),
  email: () => _t(translations.email),
  firstName: () => _t(translations.firstName), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) duplicate
  lastName: () => _t(translations.lastName), //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) duplicate
  roles: () => _t(translations.roles),
  stores: () => _t(translations.stores),
  Logged_in_Successfully: () => _t(translations.Logged_in_Successfully),
  Incorrect_Username_or_Password_Please_enter_correct_Username_Password: () =>
    _t(
      translations.Incorrect_Username_or_Password_Please_enter_correct_Username_Password,
    ),
  Cant_Add_New_Unit_This_Unit_already_Exits: () =>
    _t(translations.Cant_Add_New_Unit_This_Unit_already_Exits),
  Added_New_Unit_Successfully: () =>
    _t(translations.Added_New_Unit_Successfully),
  Cant_Add_New_Unit: () => _t(translations.Cant_Add_New_Unit),
  Add_New: () => _t(translations.Add_New),
  Add_Unit: () => _t(translations.Add_Unit),
  Type_here: () => _t(translations.Type_here),
  Today_Only: () => _t(translations.Today_Only),
  Fri_Sun: () => _t(translations.Fri_Sun),
  Mon_Thur: () => _t(translations.Mon_Thur),
  Thur_Fri: () => _t(translations.Thur_Fri),
  isDeleted: () => _t(translations.isDeleted),
  menuTag: () => _t(translations.menuTag),
  Menu_Image_missing_please_add_Menu_Image: () =>
    _t(translations.Menu_Image_missing_please_add_Menu_Image),
  Menu_Uploaded_Successfully: () => _t(translations.Menu_Uploaded_Successfully),
  Successfully_Deleted_Menus: () => _t(translations.Successfully_Deleted_Menus),
  Drop_or_click_to_select_picture: () =>
    _t(translations.Drop_or_click_to_select_picture),
  showAt: () => _t(translations.showAt),
  Select_merchant_first: () => _t(translations.Select_merchant_first),
  Select_Store: () => _t(translations.Select_store),
  Click_below_image: () => _t(translations.Click_below_image),
  Product_Tag: () => _t(translations.Product_Tag),
  Tag_Name_Missing: () => _t(translations.Tag_Name_Missing),
  Tag_CN_Name_Missing: () => _t(translations.Tag_CN_Name_Missing),
  Tag_Type_Missing: () => _t(translations.Tag_Type_Missing),
  Copy: () => _t(translations.Copy),
  Successfully_Deleted_Flyers_Item_List: () =>
    _t(translations.Successfully_Deleted_Flyers_Item_List),
  Flyers_Item_List: () => _t(translations.Flyers_Item_List),
  Store: () => _t(translations.Store),
  CurrentWeek: () => _t(translations.CurrentWeek),
  All: () => _t(translations.All),
  retake: () => _t(translations.retake),
  Capture: () => _t(translations.Capture),
  upload: () => _t(translations.upload),
  Take_a_photo_and_upload_this_weeks_flyer_specials: () =>
    _t(translations.Take_a_photo_and_upload_this_weeks_flyer_specials),
  Upload_successful_Please_close_the_browser: () =>
    _t(translations.Upload_successful_Please_close_the_browser),
  Store_Uploaded_Image: () => _t(translations.Store_Uploaded_Image),
  Browse_Image: () => _t(translations.Browse_Image),
  FlyerItems_related_to_this_FlyerItemList_will_also_be_deleted: () =>
    _t(
      translations.FlyerItems_related_to_this_FlyerItemList_will_also_be_deleted,
    ),
  NO_IMAGE_FOUND: () => _t(translations.NO_IMAGE_FOUND),
  SEARCH_SELECT_CREATE_FLYER: () => _t(translations.SEARCH_SELECT_CREATE_FLYER),
  CREATE_FLYER_OWN_IMAGE: () => _t(translations.CREATE_FLYER_OWN_IMAGE),
  SEARCH_FOR_IMAGE: () => _t(translations.SEARCH_FOR_IMAGE),
  VALID_LIST: () => _t(translations.VALID_LIST),
  English_Name: () => _t(translations.English_Name),
  Chinese_Name: () => _t(translations.Chinese_Name),
  DISPLAYS_VALID_ITEMS: () => _t(translations.DISPLAYS_VALID_ITEMS),
  DISPLAYS_BOTH_EXPIRED_AND_NON_EXPIRED_ITEMS: () =>
    _t(translations.DISPLAYS_BOTH_EXPIRED_AND_NON_EXPIRED_ITEMS),
  TOTAL_PRODUCTS: () => _t(translations.TOTAL_PRODUCTS),
  Thur_Wed: () => _t(translations.Thur_Wed),
  Fri_Thur: () => _t(translations.Fri_Thur),
  Name_of_The_Role: () => _t(translations.Name_of_The_Role),
  Select_Tag: () => _t(translations.Select_Tag),
  Photos: () => _t(translations.Photos),
  Key: () => _t(translations.Key),
  Value: () => _t(translations.Value),
  Type: () => _t(translations.Type),
  KeyInfo: () => _t(translations.KeyInfo),
  ValueInfo: () => _t(translations.ValueInfo),
  TypeInfo: () => _t(translations.TypeInfo),
  DuplicateKeyTypeError: () => _t(translations.DuplicateKeyTypeError),
  Actions: () => _t(translations.Actions),
  Add: () => _t(translations.Add),
  MetaData: () => _t(translations.MetaData),
  Content: () => _t(translations.Content),
  ShowAt: () => _t(translations.ShowAt),
  CreatedBy: () => _t(translations.CreatedBy),
  URL: () => _t(translations.URL),
  BackURL: () => _t(translations.BackURL),
  SecondBackURL: () => _t(translations.SecondBackURL),
  Interval: () => _t(translations.Interval),
  ScrapeTime: () => _t(translations.ScrapeTime),
  CreateFlyerScraperSource: () => _t(translations.CreateFlyerScraperSource),
  AI_Scrape: () => _t(translations.AI_Scrape),
  AI_Scrape_Enabled: () => _t(translations.AI_Scrape_Enabled),
  AI_Scrape_Enabled_Tooltip: () => _t(translations.AI_Scrape_Enabled_Tooltip),
  Prompt_Config_Override: () => _t(translations.Prompt_Config_Override),
  Prompt_Config_Override_Hint: () =>
    _t(translations.Prompt_Config_Override_Hint),
  System_Prompt: () => _t(translations.System_Prompt),
  Developer_Prompt: () => _t(translations.Developer_Prompt),
  User_Prompt_Template: () => _t(translations.User_Prompt_Template),
  User_Prompt_Template_Hint: () => _t(translations.User_Prompt_Template_Hint),
  Output_Schema: () => _t(translations.Output_Schema),
  Model: () => _t(translations.Model),
  Temperature: () => _t(translations.Temperature),
  Top_P: () => _t(translations.Top_P),
  Max_Output_Tokens: () => _t(translations.Max_Output_Tokens),
  Reasoning_Effort: () => _t(translations.Reasoning_Effort),
  Response_Format: () => _t(translations.Response_Format),
  Seed: () => _t(translations.Seed),
  Few_Shot_Examples: () => _t(translations.Few_Shot_Examples),
  Add_Example: () => _t(translations.Add_Example),
  Remove: () => _t(translations.Remove),
  Example_Input: () => _t(translations.Example_Input),
  Example_Output: () => _t(translations.Example_Output),
  Fall_Back_To_Global: () => _t(translations.Fall_Back_To_Global),
  Scrape_Mode: () => _t(translations.Scrape_Mode),
  Scrape_Mode_Tooltip: () => _t(translations.Scrape_Mode_Tooltip),
  Agent: () => _t(translations.Agent),
  Single_Shot: () => _t(translations.Single_Shot),
  Agent_Hints: () => _t(translations.Agent_Hints),
  Agent_Hints_Hint: () => _t(translations.Agent_Hints_Hint),
  Mode_Single_Shot_Only: () => _t(translations.Mode_Single_Shot_Only),
  Mode_Agent_Only: () => _t(translations.Mode_Agent_Only),
  Override: () => _t(translations.Override),
  Enabled: () => _t(translations.Enabled),
  Disabled: () => _t(translations.Disabled),
  Preview_Resolved_Config: () => _t(translations.Preview_Resolved_Config),
  Resolved_Scrape_Config: () => _t(translations.Resolved_Scrape_Config),
  Use_Ai_Scraper: () => _t(translations.Use_Ai_Scraper),
  Global_Enabled: () => _t(translations.Global_Enabled),
  Source_Ai_Scrape_Enabled: () => _t(translations.Source_Ai_Scrape_Enabled),
  Fetch_Strategy: () => _t(translations.Fetch_Strategy),
  Overridden_Fields: () => _t(translations.Overridden_Fields),
  Invalid_Output_Schema_JSON: () => _t(translations.Invalid_Output_Schema_JSON),
  Invalid_Few_Shot_Output_JSON: () =>
    _t(translations.Invalid_Few_Shot_Output_JSON),
  Day: () => _t(translations.Day),
  Time: () => _t(translations.Time),
  TimeFormatHHmm: () => _t(translations.TimeFormatHHmm),
  Provinces: () => _t(translations.Provinces),
  Flipp_Merchant: () => _t(translations.Flipp_Merchant),
  Flipp_PostalCode_Tooltip: () => _t(translations.Flipp_PostalCode_Tooltip),
  Postal_Code_Example: () => _t(translations.Postal_Code_Example),
  Invalid_Postal_Code: () => _t(translations.Invalid_Postal_Code),
  FlyerScraperSourceUploadedSuccessfully: () =>
    _t(translations.FlyerScraperSourceUploadedSuccessfully),
  PlaceNameNotExist: () => _t(translations.PlaceNameNotExist),
  UnableToExtractStoreDetails: () =>
    _t(translations.UnableToExtractStoreDetails),
  GoogleMapStoreURL: () => _t(translations.GoogleMapStoreURL),
  GetDetails: () => _t(translations.GetDetails),
  Address: () => _t(translations.Address),
  City: () => _t(translations.City),
  Country: () => _t(translations.Country),
  Province: () => _t(translations.Province),
  Street: () => _t(translations.Street),
  Zip: () => _t(translations.Zip),
  GoogleMapUrl: () => _t(translations.GoogleMapUrl),
  Signature: () => _t(translations.Signature),
  SETTINGS_PAGE: () => _t(translations.SETTINGS_PAGE),
  ALLOW_ACCESS_TO_SETTINGS_PAGE: () =>
    _t(translations.ALLOW_ACCESS_TO_SETTINGS_PAGE),
  START_INDEXING_FLYERS: () => _t(translations.START_INDEXING_FLYERS),
  START_INDEXING_PROMOTIONS: () => _t(translations.START_INDEXING_PROMOTIONS),
  START_INDEXING_STORES: () => _t(translations.START_INDEXING_STORES),
  START_INDEXING_MERCHANTS: () => _t(translations.START_INDEXING_MERCHANTS),
  START_INDEXING_MENUS: () => _t(translations.START_INDEXING_MENUS),
  ELASTIC_TRIGGER: () => _t(translations.ELASTIC_TRIGGER),
  CLEAR_ALL_CACHE: () => _t(translations.CLEAR_ALL_CACHE),
  OPTION_SELECTED: () => _t(translations.OPTION_SELECTED),
  MESSAGE: () => _t(translations.MESSAGE),
  CACHE: () => _t(translations.CACHE),
  INITIALIZING_INDEXING: () => _t(translations.INITIALIZING_INDEXING),
  INDEXING_SUCCESS: () => _t(translations.INDEXING_SUCCESS),
  INDEXING_FAILED: () => _t(translations.INDEXING_FAILED),
  INITIALIZE_CLEAR_ALL_CACHE: () => _t(translations.INITIALIZE_CLEAR_ALL_CACHE),
  CLEAR_ALL_CACHE_SUCCESS: () => _t(translations.CLEAR_ALL_CACHE_SUCCESS),
  CLEAR_ALL_CACHE_FAILED: () => _t(translations.CLEAR_ALL_CACHE_FAILED),
  SEO_KEYWORDS_ENGLISH: () => _t(translations.SEO_KEYWORDS_ENGLISH),
  SEO_DESCRIPTION_ENGLISH: () => _t(translations.SEO_DESCRIPTION_ENGLISH),
  SEO_KEYWORDS_CHINESE: () => _t(translations.SEO_KEYWORDS_CHINESE),
  SEO_DESCRIPTION_CHINESE: () => _t(translations.SEO_DESCRIPTION_CHINESE),
  SEO_KEYWORDS_FRENCH: () => _t(translations.SEO_KEYWORDS_FRENCH),
  SEO_DESCRIPTION_FRENCH: () => _t(translations.SEO_DESCRIPTION_FRENCH),
  SEO_KEYWORDS_PLACEHOLDER: () => _t(translations.SEO_KEYWORDS_PLACEHOLDER),
  Search_Keywords: () => _t(translations.Search_Keywords),
  TEST_ENVIRONMENT_CHANGES_HERE_WONT_AFFECT_WWW_GOFLYER_CA: () =>
    _t(translations.TEST_ENVIRONMENT_CHANGES_HERE_WONT_AFFECT_WWW_GOFLYER_CA),
  UNSELECT_ALL: () => _t(translations.UNSELECT_ALL),
  SELECT_ALL: () => _t(translations.SELECT_ALL),
  ForgotPassword: () => _t(translations.ForgotPassword),
  ResetPassword: () => _t(translations.ResetPassword),
  EnterUsername: () => _t(translations.EnterUsername),
  UsernameLabel: () => _t(translations.UsernameLabel),
  UsernameEmptyError: () => _t(translations.UsernameEmptyError),
  EmailEmptyError: () => _t(translations.EmailEmptyError),
  EmailInvalidError: () => _t(translations.EmailInvalidError),
  MaxAttemptsReachedError: () => _t(translations.MaxAttemptsReachedError),
  GeneralError: () => _t(translations.GeneralError),
  GeneralErrorWithInfo: () => _t(translations.GeneralErrorWithInfo),
  ContactAdmin: () => _t(translations.ContactAdmin),
  VerifiedEnterEmail: () => _t(translations.VerifiedEnterEmail),
  ResetEmailSent: () => _t(translations.ResetEmailSent),
  CancelButton: () => _t(translations.CancelButton),
  ProcessButton: () => _t(translations.ProcessButton),
  SubmitButton: () => _t(translations.SubmitButton),
  Create_Flyer_Item: () => _t(translations.Create_Flyer_Item),
  Create_Item: () => _t(translations.Create_Item),
  Create_Item_Without_Image: () => _t(translations.Create_Item_Without_Image),

  Create_Item_From_local: () => _t(translations.Create_Item_From_local),
  Create_New_Flyer_Item_With_Placeholder_Image: () =>
    _t(translations.Create_New_Flyer_Item_With_Placeholder_Image),
  Create_New_Flyer_Item_With_No_Placeholder_Image: () =>
    _t(translations.Create_New_Flyer_Item_With_No_Placeholder_Image),
  PasswordResetSuccessful: () => _t(translations.PasswordResetSuccessful),
  CheckEmailInstructions: () => _t(translations.CheckEmailInstructions),
  Close: () => _t(translations.Close),
  ResetPasswordError: () => _t(translations.ResetPasswordError),
  Please_select_a_replacement_unit: () =>
    _t(translations.Please_select_a_replacement_unit),
  START_INDEXING_FLYERS_ITEMS: () =>
    _t(translations.START_INDEXING_FLYERS_ITEMS),
  allow_user_creation_without_merchant_store_category: () =>
    _t(translations.allow_user_creation_without_merchant_store_category),
  flyer_scraper: () => _t(translations.flyer_scraper),
  flyerGenerationConfirmation: () =>
    _t(translations.flyerGenerationConfirmation),
  flyerGenerationPrompt: () => _t(translations.flyerGenerationPrompt),
  generatedFlyersTitle: () => _t(translations.generatedFlyersTitle),
  flyerSetsDescription: () => _t(translations.flyerSetsDescription),
  noFlyersAvailable: () => _t(translations.noFlyersAvailable),
  flyerSetLabel: () => _t(translations.flyerSetLabel),
  statusLabel: () => _t(translations.statusLabel),
  Automated_Layout_Test_Status: () =>
    _t(translations.Automated_Layout_Test_Status),
  Found: () => _t(translations.Found),
  Yes: () => _t(translations.Yes),
  No: () => _t(translations.No),
  Job_ID: () => _t(translations.Job_ID),
  State: () => _t(translations.State),
  Progress: () => _t(translations.Progress),
  Estimated_Total_Jobs: () => _t(translations.Estimated_Total_Jobs),
  Estimated_Total_Time: () => _t(translations.Estimated_Total_Time),
  Estimated_Remaining_Time: () => _t(translations.Estimated_Remaining_Time),
  Estimated_Times_Note: () => _t(translations.Estimated_Times_Note),
  Failed_Reason: () => _t(translations.Failed_Reason),
  No_status_data_available: () => _t(translations.No_status_data_available),
  downloadAllButton: () => _t(translations.downloadAllButton),
  downloadAllZipButton: () => _t(translations.downloadAllZipButton),
  downloadAllImagesButton: () => _t(translations.downloadAllImagesButton),
  createdOnLabel: () => _t(translations.createdOnLabel),
  completedOnLabel: () => _t(translations.completedOnLabel),
  failedOnLabel: () => _t(translations.failedOnLabel),
  totalFlyerItemsLabel: () => _t(translations.totalFlyerItemsLabel),
  validityLabel: () => _t(translations.validityLabel),
  generatedImagesLabel: () => _t(translations.generatedImagesLabel),
  Figma_Health_Monitor: () => _t(translations.Figma_Health_Monitor),
  Last_updated: () => _t(translations.Last_updated),
  Refresh: () => _t(translations.Refresh),
  Refreshing: () => _t(translations.Refreshing),
  Unable_to_load_health_statistics: () =>
    _t(translations.Unable_to_load_health_statistics),
  Total_Computers: () => _t(translations.Total_Computers),
  Registered_in_system: () => _t(translations.Registered_in_system),
  Healthy: () => _t(translations.Healthy),
  Currently_active: () => _t(translations.Currently_active),
  Stale: () => _t(translations.Stale),
  Not_updated_recently: () => _t(translations.Not_updated_recently),
  Inactive: () => _t(translations.Inactive),
  Not_responding: () => _t(translations.Not_responding),
  Recently_Active: () => _t(translations.Recently_Active),
  Active_in_last_24h: () => _t(translations.Active_in_last_24h),
  Search_computers_placeholder: () =>
    _t(translations.Search_computers_placeholder),
  No_Computers_Found: () => _t(translations.No_Computers_Found),
  Try_adjusting_your_search_or_filters: () =>
    _t(translations.Try_adjusting_your_search_or_filters),
  No_computers_have_been_registered_yet: () =>
    _t(translations.No_computers_have_been_registered_yet),
  Computer_Name: () => _t(translations.Computer_Name),
  Last_Check: () => _t(translations.Last_Check),
  Status: () => _t(translations.Status),
  Time_Elapsed: () => _t(translations.Time_Elapsed),
  Health: () => _t(translations.Health),
  Never: () => _t(translations.Never),
  few_seconds_ago: () => _t(translations.few_seconds_ago),
  View_Details: () => _t(translations.View_Details),
  Delete_computer: () => _t(translations.Delete_computer),
  Health_Details: () => _t(translations.Health_Details),
  Currently_Healthy: () => _t(translations.Currently_Healthy),
  Computer_ID: () => _t(translations.Computer_ID),
  flyerItemLabel: () => _t(translations.flyerItemLabel),
  downloadButton: () => _t(translations.downloadButton),
  noImagesAvailable: () => _t(translations.noImagesAvailable),
  errorDetailsLabel: () => _t(translations.errorDetailsLabel),
  noErrorDetailsMessage: () => _t(translations.noErrorDetailsMessage),
  retryAttemptsLabel: () => _t(translations.retryAttemptsLabel),
  alt: () => _t(translations.alt),
  source: () => _t(translations.source),
  mediaType: () => _t(translations.mediaType),
  height: () => _t(translations.height),
  width: () => _t(translations.width),
  s3Size: () => _t(translations.s3Size),
  splitRows: () => _t(translations.splitRows),
  splitCols: () => _t(translations.splitCols),
  sourceSmall: () => _t(translations.sourceSmall),
  sourceTinyPng: () => _t(translations.sourceTinyPng),
  Edit_Image_Details: () => _t(translations.Edit_Image_Details),
  Create_New_Image: () => _t(translations.Create_New_Image),
  Flyers_Folder: () => _t(translations.Flyers_Folder),
  Product_Images_Folder: () => _t(translations.Product_Images_Folder),
  Original_Image_Preview: () => _t(translations.Original_Image_Preview),
  Small_Image_Preview: () => _t(translations.Small_Image_Preview),
  Tiny_PNG_Preview: () => _t(translations.Tiny_PNG_Preview),
  Filename_without_extension: () => _t(translations.Filename_without_extension),
  S3_Key_read_only: () => _t(translations.S3_Key_read_only),
  Image: () => _t(translations.Image),
  Image_Preview: () => _t(translations.Image_Preview),
  Images: () => _t(translations.Images),
  Key_Tooltip_Info: () => _t(translations.key_tooltip_info),
  Value_Tooltip_Info: () => _t(translations.value_tooltip_info),
  Type_Tooltip_Info: () => _t(translations.type_tooltip_info),
  Banner: () => _t(translations.Banner),
  banner_create_success: () => _t(translations.banner_create_success),
  banner_update_success: () => _t(translations.banner_update_success),
  banner_section_identity: () => _t(translations.banner_section_identity),
  banner_section_content: () => _t(translations.banner_section_content),
  banner_section_link: () => _t(translations.banner_section_link),
  banner_section_images: () => _t(translations.banner_section_images),
  banner_section_targeting: () => _t(translations.banner_section_targeting),
  banner_section_preview: () => _t(translations.banner_section_preview),
  banner_name: () => _t(translations.banner_name),
  banner_name_helper: () => _t(translations.banner_name_helper),
  banner_placement: () => _t(translations.banner_placement),
  banner_status: () => _t(translations.banner_status),
  banner_priority: () => _t(translations.banner_priority),
  banner_priority_helper: () => _t(translations.banner_priority_helper),
  banner_valid_start: () => _t(translations.banner_valid_start),
  banner_valid_start_helper: () => _t(translations.banner_valid_start_helper),
  banner_valid_end: () => _t(translations.banner_valid_end),
  banner_valid_end_helper: () => _t(translations.banner_valid_end_helper),
  banner_house_creative_note: () => _t(translations.banner_house_creative_note),
  banner_fallback_note: () => _t(translations.banner_fallback_note),
  banner_eyebrow: () => _t(translations.banner_eyebrow),
  banner_headline: () => _t(translations.banner_headline),
  banner_title_badge: () => _t(translations.banner_title_badge),
  banner_subtitle: () => _t(translations.banner_subtitle),
  banner_cta: () => _t(translations.banner_cta),
  banner_footnote: () => _t(translations.banner_footnote),
  banner_link_type: () => _t(translations.banner_link_type),
  banner_link_url: () => _t(translations.banner_link_url),
  banner_link_url_internal_helper: () =>
    _t(translations.banner_link_url_internal_helper),
  banner_link_url_external_helper: () =>
    _t(translations.banner_link_url_external_helper),
  banner_sponsored: () => _t(translations.banner_sponsored),
  banner_sponsored_tooltip: () => _t(translations.banner_sponsored_tooltip),
  banner_advertiser_name: () => _t(translations.banner_advertiser_name),
  banner_merchant: () => _t(translations.banner_merchant),
  banner_desktop_image: () => _t(translations.banner_desktop_image),
  banner_desktop_image_helper: () =>
    _t(translations.banner_desktop_image_helper),
  banner_mobile_image: () => _t(translations.banner_mobile_image),
  banner_mobile_image_helper: () => _t(translations.banner_mobile_image_helper),
  banner_target_center: () => _t(translations.banner_target_center),
  banner_target_radius: () => _t(translations.banner_target_radius),
  banner_target_locales: () => _t(translations.banner_target_locales),
  banner_target_platforms: () => _t(translations.banner_target_platforms),
  banner_target_stores: () => _t(translations.banner_target_stores),
  banner_target_categories: () => _t(translations.banner_target_categories),
  banner_targeting_empty_note: () =>
    _t(translations.banner_targeting_empty_note),
  banner_clear_targeting: () => _t(translations.banner_clear_targeting),
  banner_name_required: () => _t(translations.banner_name_required),
  banner_placement_required: () => _t(translations.banner_placement_required),
  banner_desktop_image_required: () =>
    _t(translations.banner_desktop_image_required),
  banner_link_url_internal_invalid: () =>
    _t(translations.banner_link_url_internal_invalid),
  banner_link_url_offsite_invalid: () =>
    _t(translations.banner_link_url_offsite_invalid),
  banner_link_url_external_invalid: () =>
    _t(translations.banner_link_url_external_invalid),
  banner_link_url_unsafe: () => _t(translations.banner_link_url_unsafe),
  banner_radius_required_with_center: () =>
    _t(translations.banner_radius_required_with_center),
  banner_center_required_with_radius: () =>
    _t(translations.banner_center_required_with_radius),
  banner_radius_too_large: () => _t(translations.banner_radius_too_large),
  banner_priority_negative: () => _t(translations.banner_priority_negative),
  banner_field_too_long: () => _t(translations.banner_field_too_long),
  banner_state_draft: () => _t(translations.banner_state_draft),
  banner_state_paused: () => _t(translations.banner_state_paused),
  banner_state_archived: () => _t(translations.banner_state_archived),
  banner_state_scheduled: () => _t(translations.banner_state_scheduled),
  banner_state_expired: () => _t(translations.banner_state_expired),
  banner_state_live: () => _t(translations.banner_state_live),
  banner_state: () => _t(translations.banner_state),
  banner_created_by: () => _t(translations.banner_created_by),
  banner_validity: () => _t(translations.banner_validity),
  banner_link_pair_required: () => _t(translations.banner_link_pair_required),
  banner_cta_needs_link: () => _t(translations.banner_cta_needs_link),
  banner_content_all_optional: () =>
    _t(translations.banner_content_all_optional),
  banner_required_hint: () => _t(translations.banner_required_hint),
  banner_translate_field: () => _t(translations.banner_translate_field),
  banner_translate_no_source: () => _t(translations.banner_translate_no_source),
  banner_translate_all: () => _t(translations.banner_translate_all),
  banner_translate_all_tooltip: () =>
    _t(translations.banner_translate_all_tooltip),
  banner_translate_filled: () => _t(translations.banner_translate_filled),
  banner_translate_nothing_to_do: () =>
    _t(translations.banner_translate_nothing_to_do),
  banner_translate_over_limit: () =>
    _t(translations.banner_translate_over_limit),
  banner_tip_name: () => _t(translations.banner_tip_name),
  banner_tip_placement: () => _t(translations.banner_tip_placement),
  banner_tip_status: () => _t(translations.banner_tip_status),
  banner_tip_priority: () => _t(translations.banner_tip_priority),
  banner_tip_valid_start: () => _t(translations.banner_tip_valid_start),
  banner_tip_valid_end: () => _t(translations.banner_tip_valid_end),
  banner_tip_eyebrow: () => _t(translations.banner_tip_eyebrow),
  banner_tip_headline: () => _t(translations.banner_tip_headline),
  banner_tip_title_badge: () => _t(translations.banner_tip_title_badge),
  banner_tip_subtitle: () => _t(translations.banner_tip_subtitle),
  banner_tip_cta: () => _t(translations.banner_tip_cta),
  banner_tip_footnote: () => _t(translations.banner_tip_footnote),
  banner_tip_link_type: () => _t(translations.banner_tip_link_type),
  banner_tip_link_url: () => _t(translations.banner_tip_link_url),
  banner_tip_advertiser: () => _t(translations.banner_tip_advertiser),
  banner_tip_merchant: () => _t(translations.banner_tip_merchant),
  banner_tip_desktop_image: () => _t(translations.banner_tip_desktop_image),
  banner_tip_mobile_image: () => _t(translations.banner_tip_mobile_image),
  banner_tip_map_url: () => _t(translations.banner_tip_map_url),
  banner_tip_longitude: () => _t(translations.banner_tip_longitude),
  banner_tip_latitude: () => _t(translations.banner_tip_latitude),
  banner_tip_radius: () => _t(translations.banner_tip_radius),
  banner_tip_locales: () => _t(translations.banner_tip_locales),
  banner_tip_platforms: () => _t(translations.banner_tip_platforms),
  banner_tip_stores: () => _t(translations.banner_tip_stores),
  banner_tip_categories: () => _t(translations.banner_tip_categories),
  banner_select_placeholder: () => _t(translations.banner_select_placeholder),
  banner_all_placements: () => _t(translations.banner_all_placements),
  banner_all_statuses: () => _t(translations.banner_all_statuses),
  banner_preview_desktop: () => _t(translations.banner_preview_desktop),
  banner_preview_mobile: () => _t(translations.banner_preview_mobile),
  banner_preview_empty: () => _t(translations.banner_preview_empty),
  Calculate_Save: () => _t(translations.Calculate_Save),
  Convert_Unit: () => _t(translations.Convert_Unit),
  regularPriceRequiredForSavings: () =>
    _t(translations.regularPriceRequiredForSavings),
  salePriceCannotExceedRegularPrice: () =>
    _t(translations.salePriceCannotExceedRegularPrice),
  ViewFlyer: () => _t(translations.ViewFlyer),
  Smart_Flyer: () => _t(translations.SMART_FLYER),
  AI_Generated: () => _t(translations.AI_GENERATED),
  AI_Generation_Model: () => _t(translations.AI_Generation_Model),
  Figma_Generated: () => _t(translations.FIGMA_GENERATED),
  Calculate_Save_Tooltip: () => _t(translations.Calculate_Save_Tooltip),
  English_Name_Tooltip: () => _t(translations.English_Name_Tooltip),
  Convert_Unit_Tooltip: () => _t(translations.Convert_Unit_Tooltip),
  Search_Tab_Dependent_Info: () => _t(translations.Search_Tab_Dependent_Info),
  Chinese_Name_Tooltip: () => _t(translations.Chinese_Name_Tooltip),
  Quantity_Tooltip: () => _t(translations.Quantity_Tooltip),
  Sale_Price_Tooltip: () => _t(translations.Sale_Price_Tooltip),
  Regular_Price_Tooltip: () => _t(translations.Regular_Price_Tooltip),
  Limit_Tooltip: () => _t(translations.Limit_Tooltip),
  Rank_Tooltip: () => _t(translations.Rank_Tooltip),
  Rank_Radius_Limit: () => _t(translations.Rank_Radius_Limit),
  Rank_Radius_Limit_Tooltip: () => _t(translations.Rank_Radius_Limit_Tooltip),
  Rank_Radius_Both_Error: () => _t(translations.Rank_Radius_Both_Error),
  Unit_Tooltip: () => _t(translations.Unit_Tooltip),
  Promotion_Tag_Tooltip: () => _t(translations.Promotion_Tag_Tooltip),
  Category_Tooltip: () => _t(translations.Category_Tooltip),
  Export_Categories: () => _t(translations.exportCategories),
  Select_Categories_To_Export: () => _t(translations.selectCategoriesToInclude),
  Select_All: () => _t(translations.selectAll),
  Export: () => _t(translations.export),
  Import_Excel: () => _t(translations.Import_Excel),
  Select_Excel_File_And_Categories: () =>
    _t(translations.Select_Excel_File_And_Categories),
  Select_Excel_File: () => _t(translations.Select_Excel_File),
  Select_Categories_To_Import: () =>
    _t(translations.Select_Categories_To_Import),
  Import: () => _t(translations.Import),
  Importing: () => _t(translations.Importing),
  Export_Categories_Description: () =>
    _t(translations.Export_Categories_Description),
  Available_Categories: () => _t(translations.Available_Categories),
  No_Categories_Available: () => _t(translations.No_Categories_Available),
  Selected_Categories: () => _t(translations.Selected_Categories),
  Please_Select_At_Least_One_Category: () =>
    _t(translations.Please_Select_At_Least_One_Category),
  Exporting: () => _t(translations.Exporting),
  Change_File: () => _t(translations.Change_File),
  Drop_Excel_File_Here: () => _t(translations.Drop_Excel_File_Here),
  START_INDEXING_FLYERS_ITEMS_LIST: () =>
    _t(translations.START_INDEXING_FLYERS_ITEMS_LIST),
  SYNC_AI_GENERATED_FLYER_ITEMS: () =>
    _t(translations.SYNC_AI_GENERATED_FLYER_ITEMS),
  SYNC_AI_GENERATED_FLYER_ITEMS_TOOLTIP: () =>
    _t(translations.SYNC_AI_GENERATED_FLYER_ITEMS_TOOLTIP),
  ENQUEUE_CLIP_IMAGE_EMBEDDINGS_NON_EXPIRED_LISTS: () =>
    _t(translations.ENQUEUE_CLIP_IMAGE_EMBEDDINGS_NON_EXPIRED_LISTS),
  ENQUEUE_CLIP_IMAGE_EMBEDDINGS_NON_EXPIRED_LISTS_TOOLTIP: () =>
    _t(translations.ENQUEUE_CLIP_IMAGE_EMBEDDINGS_NON_EXPIRED_LISTS_TOOLTIP),
  bulkCalculateSave: () => _t(translations.bulkCalculateSave),
  Tools: () => _t(translations.tools),
  bulkCalculateSaveDescription: () =>
    _t(translations.bulkCalculateSaveDescription),
  Statistics: () => _t(translations.Statistics),
  Total_Items: () => _t(translations.Total_Items),
  Categories_Breakdown: () => _t(translations.Categories_Breakdown),
  items: () => _t(translations.items),
  No_statistics_available: () => _t(translations.No_statistics_available),
  Error_Fetching_Statistics: () => _t(translations.Error_Fetching_Statistics),
  No_category_data_available: () => _t(translations.No_category_data_available),
  No_coordinates_available: () => _t(translations.No_coordinates_available),
  Flyer_Page: () => _t(translations.Flyer_Page),
  Height: () => _t(translations.Height),
  Width: () => _t(translations.Width),
  Component_Name: () => _t(translations.Component_Name),
  Component_ID: () => _t(translations.Component_ID),
  Coordinates_for: () => _t(translations.Coordinates_for),
  Coordinates: () => _t(translations.Coordinates),
  Show: () => _t(translations.Show),
  Count: () => _t(translations.Count),
  Figma_Component_Layout: () => _t(translations.Figma_Component_Layout),
  Batch_Edit_Templates: () => _t(translations.Batch_Edit_Templates),
  Update_Template_For_Multiple_Component_Positions: () =>
    _t(translations.Update_Template_For_Multiple_Component_Positions),
  Items_Selected: () => _t(translations.Items_Selected),
  Current_Templates: () => _t(translations.Current_Templates),
  New_Template: () => _t(translations.New_Template),
  Batch_Edit_With_Count: () => _t(translations.Batch_Edit_With_Count),
  Batch_Edit_Disabled_Tooltip: () =>
    _t(translations.Batch_Edit_Disabled_Tooltip),
  Batch_Edit_Enabled_Tooltip: () => _t(translations.Batch_Edit_Enabled_Tooltip),
  No_Items_Selected_For_Batch_Edit: () =>
    _t(translations.No_Items_Selected_For_Batch_Edit),
  Please_Select_More_Than_One_Item_For_Batch_Edit: () =>
    _t(translations.Please_Select_More_Than_One_Item_For_Batch_Edit),
  Cannot_Batch_Edit_Items_With_Mixed_Stores: () =>
    _t(translations.Cannot_Batch_Edit_Items_With_Mixed_Stores),
  Batch_Edit_Only_Works_For_Items_From_Same_Store: () =>
    _t(translations.Batch_Edit_Only_Works_For_Items_From_Same_Store),
  Selected_Items_Do_Not_Have_Valid_Store_Information: () =>
    _t(translations.Selected_Items_Do_Not_Have_Valid_Store_Information),
  Failed_To_Load_Templates_Please_Try_Again: () =>
    _t(translations.Failed_To_Load_Templates_Please_Try_Again),
  Please_Select_A_Template: () => _t(translations.Please_Select_A_Template),
  Validation_Failed: () => _t(translations.Validation_Failed),
  Successfully_Updated_Items: () => _t(translations.Successfully_Updated_Items),
  Failed_To_Save_Some_Or_All_Items: () =>
    _t(translations.Failed_To_Save_Some_Or_All_Items),
  GenericError: () => _t(translations.GenericError),
  Log_In_to_Your_Account: () => _t(translations.Log_In_to_Your_Account),
  Username_Email_or_Phone_Number: () =>
    _t(translations.Username_Email_or_Phone_Number),
  Log_In: () => _t(translations.Log_In),
  Login_with_Google: () => _t(translations.Login_with_Google),
  Dont_have_an_account_Sign_Up: () =>
    _t(translations.Dont_have_an_account_Sign_Up),
  Create_Your_Account: () => _t(translations.Create_Your_Account),
  Email_Address: () => _t(translations.Email_Address),
  Continue_with_Email: () => _t(translations.Continue_with_Email),
  Continue_with_Phone: () => _t(translations.Continue_with_Phone),
  Sign_up_with_Google: () => _t(translations.Sign_up_with_Google),
  Already_have_an_account_Log_In: () =>
    _t(translations.Already_have_an_account_Log_In),

  Login_successful_Redirecting_you_now: () =>
    _t(translations.Login_successful_Redirecting_you_now),

  Invalid_Credentials_Error: () => _t(translations.Invalid_Credentials_Error),

  Username_Password_Required_Error: () =>
    _t(translations.Username_Password_Required_Error),

  Generic_Server_Error: () => _t(translations.Generic_Server_Error),

  Verification_email_sent_Check_your_inbox_and_then_complete_signup: () =>
    _t(
      translations.Verification_email_sent_Check_your_inbox_and_then_complete_signup,
    ),

  PhoneEmptyError: () => _t(translations.PhoneEmptyError),

  OTP_sent_to_your_phone: () => _t(translations.OTP_sent_to_your_phone),

  OTP_is_required: () => _t(translations.OTP_is_required),

  Phone_verified_Please_set_your_username_and_password: () =>
    _t(translations.Phone_verified_Please_set_your_username_and_password),

  Invalid_OTP_Error: () => _t(translations.Invalid_OTP_Error),

  Password_Too_Short_Error: () => _t(translations.Password_Too_Short_Error),

  Password_Mismatch_Error: () => _t(translations.Password_Mismatch_Error),

  Sign_up_successful_Welcome_aboard: () =>
    _t(translations.Sign_up_successful_Welcome_aboard),

  Password_reset_email_sent_Check_your_inbox: () =>
    _t(translations.Password_reset_email_sent_Check_your_inbox),

  Failed_to_send_password_reset_email: () =>
    _t(translations.Failed_to_send_password_reset_email),

  Log_in_with_Google: () => _t(translations.Log_in_with_Google),

  Forgot_your_password: () => _t(translations.Forgot_your_password),

  Verify_Your_Email: () => _t(translations.Verify_Your_Email),

  Verify_Your_Phone_Number: () => _t(translations.Verify_Your_Phone_Number),

  Weve_sent_a_verification_code_to_email: () =>
    _t(translations.Weve_sent_a_verification_code_to_email),

  Weve_sent_a_verification_code_via_SMS_to_phone: () =>
    _t(translations.Weve_sent_a_verification_code_via_SMS_to_phone),

  Verification_Code: () => _t(translations.Verification_Code),

  Verify_and_Continue: () => _t(translations.Verify_and_Continue),

  Didnt_receive_a_code_Resend_Code: () =>
    _t(translations.Didnt_receive_a_code_Resend_Code),

  Back_to_Sign_Up_options: () => _t(translations.Back_to_Sign_Up_options),

  Almost_there_Secure_your_account: () =>
    _t(translations.Almost_there_Secure_your_account),
  Your_email_phone_has_been_verified_Create_username_password: () =>
    _t(
      translations.Your_email_phone_has_been_verified_Create_username_password,
    ),
  Choose_a_Username: () => _t(translations.Choose_a_Username),
  Min_3_characters: () => _t(translations.Min_3_characters),
  Create_a_Password: () => _t(translations.Create_a_Password),
  Min_6_characters: () => _t(translations.Min_6_characters),
  Confirm_Password: () => _t(translations.Confirm_Password),
  Complete_Sign_Up: () => _t(translations.Complete_Sign_Up),
  Reset_Your_Password: () => _t(translations.Reset_Your_Password),
  Enter_your_email_address_to_receive_a_password_reset_link_via_Firebase: () =>
    _t(
      translations.Enter_your_email_address_to_receive_a_password_reset_link_via_Firebase,
    ),
  Send_Password_Reset_Email: () => _t(translations.Send_Password_Reset_Email),
  Back_to_Log_In: () => _t(translations.Back_to_Log_In),
  Google_Sign_In_Failed: () => _t(translations.Google_Sign_In_Failed),
  Email_verified_Please_complete_your_profile: () =>
    _t(translations.Email_verified_Please_complete_your_profile),
  Google_authentication_successful_Please_complete_your_profile: () =>
    _t(
      translations.Google_authentication_successful_Please_complete_your_profile,
    ),
  Failed_to_send_OTP_Try_again: () =>
    _t(translations.Failed_to_send_OTP_Try_again),
  OTP_sending_process_was_not_initiated_correctly_Please_try_sending_OTP_again:
    () =>
      _t(
        translations.OTP_sending_process_was_not_initiated_correctly_Please_try_sending_OTP_again,
      ),
  Firebase_token_is_missing_Please_restart_sign_up: () =>
    _t(translations.Firebase_token_is_missing_Please_restart_sign_up),
  Invalid_or_expired_email_verification_link_Please_try_signing_up_again: () =>
    _t(
      translations.Invalid_or_expired_email_verification_link_Please_try_signing_up_again,
    ),
  Google_account: () => _t(translations.Google_account),
  Sign_up_with_Email: () => _t(translations.Sign_up_with_Email),
  Enter_your_email_address: () => _t(translations.Enter_your_email_address),
  Send_Verification_Email: () => _t(translations.Send_Verification_Email),
  Sign_up_with_Phone_Number: () => _t(translations.Sign_up_with_Phone_Number),
  Enter_your_phone_number: () => _t(translations.Enter_your_phone_number),
  Send_OTP: () => _t(translations.Send_OTP),
  Change_phone_number: () => _t(translations.Change_phone_number),
  Enter_OTP: () => _t(translations.Enter_OTP),
  Phone: () => _t(translations.Phone),
  OR: () => _t(translations.OR),
  Verification_email_sent_to: () => _t(translations.Verification_email_sent_to),
  Check_your_inbox_and_click_the_verification_link: () =>
    _t(translations.Check_your_inbox_and_click_the_verification_link),
  Failed_to_send_verification_email: () =>
    _t(translations.Failed_to_send_verification_email),
  Username_Required_Error: () => _t(translations.Username_Required_Error),
  Username_Length_Error: () => _t(translations.Username_Length_Error),
  Username_Format_Error: () => _t(translations.Username_Format_Error),
  Username_Reserved_Error: () => _t(translations.Username_Reserved_Error),
  Password_Required_Error: () => _t(translations.Password_Required_Error),
  TooManyOtpRequests: () => _t(translations.TooManyOtpRequests),
  InvalidPhoneFormat: () => _t(translations.InvalidPhoneFormat),
  InvalidOtpFormat: () => _t(translations.InvalidOtpFormat),
  Identifier_Required_Error: () => _t(translations.Identifier_Required_Error),
  TooManyLoginAttempts: () => _t(translations.TooManyLoginAttempts),
  TooManyAttempts: () => _t(translations.TooManyAttempts),
  Password_Complexity_Error: () => _t(translations.Password_Complexity_Error),
  Verification_link_already_used_or_expired: () =>
    _t(translations.Verification_link_already_used_or_expired),
  Email_verification_failed_Please_try_again: () =>
    _t(translations.Email_verification_failed_Please_try_again),
  Resend_Verification_Email: () => _t(translations.Resend_Verification_Email),
  If_you_dont_see_the_email_check_spam_folder: () =>
    _t(translations.If_you_dont_see_the_email_check_spam_folder),
  Enter_your_first_name: () => _t(translations.Enter_your_first_name),
  Last_Name_Optional: () => _t(translations.Last_Name_Optional),
  Enter_your_last_name_optional: () =>
    _t(translations.Enter_your_last_name_optional),
  FirstName_Required_Error: () => _t(translations.FirstName_Required_Error),
  Email_Username: () => _t(translations.Email_Username),
  Username_Taken_Error: () => _t(translations.Username_Taken_Error),
  EmailAlreadyRegistered: () => _t(translations.EmailAlreadyRegistered),

  EmailAlreadyRegistered_PleaseLoginOrResetPassword: () =>
    _t(translations.EmailAlreadyRegistered_PleaseLoginOrResetPassword),

  EmailRegisteredWithGoogle_PleaseLoginWithGoogle: () =>
    _t(translations.EmailRegisteredWithGoogle_PleaseLoginWithGoogle),
  Email_verified_but_signup_not_completed_Please_check_your_email_for_verification_link_and_complete_signup:
    () =>
      _t(
        translations.Email_verified_but_signup_not_completed_Please_check_your_email_for_verification_link_and_complete_signup,
      ),
  Password_Required: () => _t(translations.Password_Required),

  Passwords_Do_Not_Match: () => _t(translations.Passwords_Do_Not_Match),

  Password_Too_Short: () => _t(translations.Password_Too_Short),

  Password_Reset_Success: () => _t(translations.Password_Reset_Success),

  New_Password: () => _t(translations.New_Password),

  Enter_New_Password: () => _t(translations.Enter_New_Password),

  Confirm_New_Password: () => _t(translations.Confirm_New_Password),

  Reset_Password_with_Phone: () => _t(translations.Reset_Password_with_Phone),

  Reset_Password: () => _t(translations.Reset_Password),
  Back_to_Sign_Up: () => _t(translations.Back_to_Sign_Up),
  Phone_EmptyError: () => _t(translations.Phone_EmptyError),
  Review_Complete: () => _t(translations.Review_Complete),
  Please_review_all_your_store_information_before_completing_the_setup: () =>
    _t(
      translations.Please_review_all_your_store_information_before_completing_the_setup,
    ),
  You_can_still_make_changes_if_needed: () =>
    _t(translations.You_can_still_make_changes_if_needed),
  Find_and_Select_Your_Store: () => _t(translations.Find_and_Select_Your_Store),
  Search_for_your_store_by_name_Select_your_store_from_the_results: () =>
    _t(
      translations.Search_for_your_store_by_name_Select_your_store_from_the_results,
    ),
  Search_for_your_store: () => _t(translations.Search_for_your_store),
  Store_search: () => _t(translations.Store_search),
  Search_stores: () => _t(translations.Search_stores),
  Find_Your_Store: () => _t(translations.Find_Your_Store),
  Search_for_your_store_and_verify_the_location_on_our_map: () =>
    _t(translations.Search_for_your_store_and_verify_the_location_on_our_map),
  Store_Selected: () => _t(translations.Store_Selected),
  Find_Your_Store_Step: () => _t(translations.Find_Your_Store_Step),
  Store_Details: () => _t(translations.Store_Details),
  Complete_Setup: () => _t(translations.Complete_Setup),
  Onboarding_completed_successfully: () =>
    _t(translations.Onboarding_completed_successfully),
  No_onboarding_data_available: () =>
    _t(translations.No_onboarding_data_available),
  Phone_number_is_not_provided: () =>
    _t(translations.Phone_number_is_not_provided),
  Operating_hours_are_not_specified: () =>
    _t(translations.Operating_hours_are_not_specified),
  No_store_tags_assigned: () => _t(translations.No_store_tags_assigned),
  Website_URL_is_not_provided: () =>
    _t(translations.Website_URL_is_not_provided),
  Store_signature_is_not_specified: () =>
    _t(translations.Store_signature_is_not_specified),
  Sunday: () => _t(translations.Sunday),
  Monday: () => _t(translations.Monday),
  Tuesday: () => _t(translations.Tuesday),
  Wednesday: () => _t(translations.Wednesday),
  Thursday: () => _t(translations.Thursday),
  Friday: () => _t(translations.Friday),
  Saturday: () => _t(translations.Saturday),
  No_stores_found_Try_a_different_search: () =>
    _t(translations.No_stores_found_Try_a_different_search),
  Cant_find_your_store_You_can_proceed_to_enter_your_store_details_manually:
    () =>
      _t(
        translations.Cant_find_your_store_You_can_proceed_to_enter_your_store_details_manually,
      ),
  Search_Results: () => _t(translations.Search_Results),
  Enter_Store_Details_Manually: () =>
    _t(translations.Enter_Store_Details_Manually),
  Continue_with_Selected_Store: () =>
    _t(translations.Continue_with_Selected_Store),
  Choose_Your_Plan: () => _t(translations.Choose_Your_Plan),
  Free_Plan: () => _t(translations.Free_Plan),
  Free: () => _t(translations.Free),
  Perfect_for_getting_started: () =>
    _t(translations.Perfect_for_getting_started),
  Basic_store_setup: () => _t(translations.Basic_store_setup),
  Up_to_50_products: () => _t(translations.Up_to_50_products),
  Standard_analytics: () => _t(translations.Standard_analytics),
  Email_support: () => _t(translations.Email_support),
  Basic_customization: () => _t(translations.Basic_customization),
  Pro_Plan: () => _t(translations.Pro_Plan),
  Advanced_features_for_growing_businesses: () =>
    _t(translations.Advanced_features_for_growing_businesses),
  Everything_in_Free: () => _t(translations.Everything_in_Free),
  Unlimited_products: () => _t(translations.Unlimited_products),
  Advanced_analytics: () => _t(translations.Advanced_analytics),
  Priority_support: () => _t(translations.Priority_support),
  Custom_branding: () => _t(translations.Custom_branding),
  Advanced_integrations: () => _t(translations.Advanced_integrations),
  Marketing_tools: () => _t(translations.Marketing_tools),
  POPULAR: () => _t(translations.POPULAR),
  month: () => _t(translations.month),
  Selected: () => _t(translations.Selected),
  Select_Plan: () => _t(translations.Select_Plan),
  You_can_upgrade_anytime_after_setup: () =>
    _t(translations.You_can_upgrade_anytime_after_setup),
  day_free_trial_included: () => _t(translations.day_free_trial_included),
  Location_Information: () => _t(translations.Location_Information),
  Operating_Hours: () => _t(translations.Operating_Hours),
  Map_Preview: () => _t(translations.Map_Preview),
  Loading_Store_Details: () => _t(translations.Loading_Store_Details),
  Go_Back: () => _t(translations.Go_Back),
  Please_Fix_Following_Issues: () =>
    _t(translations.Please_Fix_Following_Issues),
  Recommendations: () => _t(translations.Recommendations),
  Manual_Entry_Mode: () => _t(translations.Manual_Entry_Mode),
  Please_Fill_Required_Information: () =>
    _t(translations.Please_Fill_Required_Information),
  All_Fields_Marked_Required: () => _t(translations.All_Fields_Marked_Required),
  Continue_To_Review: () => _t(translations.Continue_To_Review),
  Uploading: () => _t(translations.Uploading),
  Upload_Logo: () => _t(translations.Upload_Logo),
  Enter_Store_Name: () => _t(translations.Enter_Store_Name),
  Store_Name_Chinese_Optional: () =>
    _t(translations.Store_Name_Chinese_Optional),
  Save_Changes: () => _t(translations.Save_Changes),
  Edit_Store_Details: () => _t(translations.Edit_Store_Details),
  Enter_Store_Information_Below: () =>
    _t(translations.Enter_Store_Information_Below),
  You_Can_Edit_These_Details_Anytime: () =>
    _t(translations.You_Can_Edit_These_Details_Anytime),
  Review_Store_Information_Google: () =>
    _t(translations.Review_Store_Information_Google),
  You_Can_Edit_These_Details_Later: () =>
    _t(translations.You_Can_Edit_These_Details_Later),
  Province_State: () => _t(translations.Province_State),
  Postal_Code: () => _t(translations.Postal_Code),
  Postal_Code_Flipp_Merchant: () => _t(translations.Postal_Code_Flipp_Merchant),
  Contact_Reviews: () => _t(translations.Contact_Reviews),
  Not_Available: () => _t(translations.Not_Available),
  Google_Maps_URL: () => _t(translations.Google_Maps_URL),
  Google_Maps: () => _t(translations.Google_Maps),
  View_On_Google_Maps: () => _t(translations.View_On_Google_Maps),
  Enter_Phone_Number: () => _t(translations.Enter_Phone_Number),
  Open_Time: () => _t(translations.Open_Time),
  Close_Time: () => _t(translations.Close_Time),
  To: () => _t(translations.To),
  Time_Format_AM_Helper: () => _t(translations.Time_Format_AM_Helper),
  Time_Format_PM_Helper: () => _t(translations.Time_Format_PM_Helper),
  Operating_Hours_Not_Available: () =>
    _t(translations.Operating_Hours_Not_Available),
  Geographic_Coordinates: () => _t(translations.Geographic_Coordinates),
  Longitude: () => _t(translations.Longitude),
  Latitude: () => _t(translations.Latitude),
  Required_Information_Missing: () =>
    _t(translations.Required_Information_Missing),
  Recommended_Information: () => _t(translations.Recommended_Information),
  Add_Optional_Details: () => _t(translations.Add_Optional_Details),
  Ready_to_Complete_Setup: () => _t(translations.Ready_to_Complete_Setup),
  All_required_information_has_been_provided_Your_store_is_ready_to_go_live:
    () =>
      _t(
        translations.All_required_information_has_been_provided_Your_store_is_ready_to_go_live,
      ),
  Setting_up_store: () => _t(translations.Setting_up_store),
  No_store_data_available_Please_go_back_and_complete_the_previous_steps: () =>
    _t(
      translations.No_store_data_available_Please_go_back_and_complete_the_previous_steps,
    ),
  Free_Plan_Text: () => _t(translations.Free_Plan_Text),
  Pro_Plan_Text: () => _t(translations.Pro_Plan_Text),
  Store_Name_Default: () => _t(translations.Store_Name_Default),
  Store_Address_Default: () => _t(translations.Store_Address_Default),
  Edit_Details: () => _t(translations.Edit_Details),
  Contact_Information_Overview: () =>
    _t(translations.Contact_Information_Overview),
  Phone_Label: () => _t(translations.Phone_Label),
  Not_provided: () => _t(translations.Not_provided),
  Website_Label: () => _t(translations.Website_Label),
  Coordinates_Label: () => _t(translations.Coordinates_Label),
  Store_Tags_Label: () => _t(translations.Store_Tags_Label),
  No_tags_assigned: () => _t(translations.No_tags_assigned),
  Store_Signature_Label: () => _t(translations.Store_Signature_Label),
  Not_specified: () => _t(translations.Not_specified),
  Visit_Website: () => _t(translations.Visit_Website),
  Store_Details_Section: () => _t(translations.Store_Details_Section),
  Store_Information: () => _t(translations.Store_Information),
  Official_Website: () => _t(translations.Official_Website),
  Google_Phone_Number: () => _t(translations.Google_Phone_Number),
  Enter_store_signature_or_identifier: () =>
    _t(translations.Enter_store_signature_or_identifier),
  Store_tags_tooltip: () => _t(translations.Store_tags_tooltip),
  Store_signature_tooltip: () => _t(translations.Store_signature_tooltip),
  Figma_Health_Monitoring: () => _t(translations.Figma_Health_Monitoring),
  Smartfly_Review: () => _t(translations.Smartfly_Review),
  noImagesSelected: () => _t(translations.NO_IMAGES_SELECTED),
  allImagesAlreadyRemoved: () => _t(translations.ALL_IMAGES_ALREADY_REMOVED),
  removeBackgroundAgainTitle: () =>
    _t(translations.REMOVE_BACKGROUND_AGAIN_TITLE),
  removeBackgroundAgainDescription: () =>
    _t(translations.REMOVE_BACKGROUND_AGAIN_DESCRIPTION),
  failedToRemoveBackground: () => _t(translations.FAILED_TO_REMOVE_BACKGROUND),
  backgroundRemovedSuccess: () => _t(translations.BACKGROUND_REMOVED_SUCCESS),
  uploadImages: () => _t(translations.UPLOADING_IMAGES),
  removingBackground: () => _t(translations.REMOVING_BACKGROUND),
  processing: () => _t(translations.PROCESSING),
  removeBackground: () => _t(translations.REMOVE_BACKGROUND),
  SUNDAY_HOURS: () => _t(translations.SUNDAY_HOURS),
  SUNDAY_OPEN_TIME: () => _t(translations.SUNDAY_OPEN_TIME),
  SUNDAY_CLOSE_TIME: () => _t(translations.SUNDAY_CLOSE_TIME),
  SATURDAY_HOURS: () => _t(translations.SATURDAY_HOURS),
  SATURDAY_OPEN_TIME: () => _t(translations.SATURDAY_OPEN_TIME),
  SATURDAY_CLOSE_TIME: () => _t(translations.SATURDAY_CLOSE_TIME),
  WEEKDAY_HOURS: () => _t(translations.WEEKDAY_HOURS),
  BUSINESS_INFORMATION: () => _t(translations.BUSINESS_INFORMATION),
  DISCLAIMER_TEXT: () => _t(translations.DISCLAIMER_TEXT),
  STORE_LOCATION: () => _t(translations.STORE_LOCATION),
  layoutConfigurationNotice: () => _t(translations.layoutConfigurationNotice),
  layoutConfigurationNoticeWarning: () =>
    _t(translations.layoutConfigurationNoticeWarning),
  layoutNotice: () => _t(translations.layoutNotice),
  layoutExceedsConfiguration: () => _t(translations.layoutExceedsConfiguration),
  layoutConfigurationNoticeTitle: () =>
    _t(translations.layoutConfigurationNoticeTitle),
  layoutConfigurationNoticeDescription: () =>
    _t(translations.layoutConfigurationNoticeDescription),
  itemsAffected: () => _t(translations.itemsAffected),
  pageLocation: () => _t(translations.pageLocation),
  frontPage: () => _t(translations.frontPage),
  backPage: () => _t(translations.backPage),
  categoryExceedsCapacity: () => _t(translations.categoryExceedsCapacity),
  needAssistance: () => _t(translations.needAssistance),
  layoutAssistanceMessage: () => _t(translations.layoutAssistanceMessage),
  missingPositionItemCount: () => _t(translations.missingPositionItemCount),
  TWO_IMAGE_LAYOUT_GUIDE: () => _t(translations.TWO_IMAGE_LAYOUT_GUIDE),
  UPLOAD_IMAGES_GUIDE: () => _t(translations.UPLOAD_IMAGES_GUIDE),
  REMOVE_BACKGROUND_GUIDE: () => _t(translations.REMOVE_BACKGROUND_GUIDE),
  improveWithAi: () => _t(translations.IMPROVE_WITH_AI),
  improvingWithAi: () => _t(translations.IMPROVING_WITH_AI),
  improveWithAiModalTitle: () => _t(translations.IMPROVE_WITH_AI_MODAL_TITLE),
  improveWithAiSelectImage: () => _t(translations.IMPROVE_WITH_AI_SELECT_IMAGE),
  improveWithAiSelectedPreview: () =>
    _t(translations.IMPROVE_WITH_AI_SELECTED_PREVIEW),
  improveWithAiPromptSectionTitle: () =>
    _t(translations.IMPROVE_WITH_AI_PROMPT_SECTION_TITLE),
  improveWithAiPromptHint: () => _t(translations.IMPROVE_WITH_AI_PROMPT_HINT),
  improveWithAiPromptPlaceholder: () =>
    _t(translations.IMPROVE_WITH_AI_PROMPT_PLACEHOLDER),
  improveWithAiSavedPromptPreview: () =>
    _t(translations.IMPROVE_WITH_AI_SAVED_PROMPT_PREVIEW),
  startAiImprovement: () => _t(translations.START_AI_IMPROVEMENT),
  failedToAiImprove: () => _t(translations.FAILED_TO_AI_IMPROVE),
  aiImprovementSuccess: () => _t(translations.AI_IMPROVEMENT_SUCCESS),
  aiImprovementAlreadyRunning: () =>
    _t(translations.AI_IMPROVEMENT_ALREADY_RUNNING),
  aiImprovementSessionExpired: () =>
    _t(translations.AI_IMPROVEMENT_SESSION_EXPIRED),
  IMPROVE_WITH_AI_GUIDE: () => _t(translations.IMPROVE_WITH_AI_GUIDE),
  SYNC_THIS_ITEM_TO_THE_STORE_S_WEBSITE_AND_MOBILE_APP: () =>
    _t(translations.SYNC_THIS_ITEM_TO_THE_STORE_S_WEBSITE_AND_MOBILE_APP),
  SYNC_THIS_ITEM_TO_THE_GO_FLYER_PLATFORM_WEBSITE_AND_MOBILE_APP: () =>
    _t(
      translations.SYNC_THIS_ITEM_TO_THE_GO_FLYER_PLATFORM_WEBSITE_AND_MOBILE_APP,
    ),
  DISPLAY_THIS_ITEM_PROMINENTLY_ON_THE_FRONT_PAGE_OF_THE_FLYER: () =>
    _t(
      translations.DISPLAY_THIS_ITEM_PROMINENTLY_ON_THE_FRONT_PAGE_OF_THE_FLYER,
    ),
  UPLOAD_IMAGE: () => _t(translations.UPLOAD_IMAGE),
  Available_Now: () => _t(translations.Available_Now),
  Sale_Price_Zero_Tooltip: () => _t(translations.Sale_Price_Zero_Tooltip),
  Export_to_Excel: () => _t(translations.Export_to_Excel),
  Export_Selected_Items_To_Excel: () =>
    _t(translations.Export_Selected_Items_To_Excel),
  Paste_a_direct_image_link_to_upload: () =>
    _t(translations.Paste_a_direct_image_link_to_upload),
  Paste_image_URL: () => _t(translations.Paste_image_URL),
  Image_URL: () => _t(translations.Image_URL),
  Enter_a_valid_image_URL_http_https: () =>
    _t(translations.Enter_a_valid_image_URL_http_https),
  Only_image_URLs_with_extensions_png_jpg_jpeg_gif_webp_bmp_svg_heic_tif_tiff_avif_or_psd_are_allowed:
    () =>
      _t(
        translations.Only_image_URLs_with_extensions_png_jpg_jpeg_gif_webp_bmp_svg_heic_tif_tiff_avif_or_psd_are_allowed,
      ),
  Preview: () => _t(translations.Preview),
  Loading: () => _t(translations.Loading),
  Loading_preview: () => _t(translations.Loading_preview),
  Could_not_load_image_Check_the_URL: () =>
    _t(translations.Could_not_load_image_Check_the_URL),
  Paste_a_direct_image_link_and_click_Preview: () =>
    _t(translations.Paste_a_direct_image_link_and_click_Preview),
  Loaded: () => _t(translations.Loaded),
  Change_URL: () => _t(translations.Change_URL),
  Unsupported_file_type_Allowed_image_or_psd: () =>
    _t(translations.Unsupported_file_type_Allowed_image_or_psd),
  Image_size_exceeds_the_10MB_limit_Please_use_a_smaller_image: () =>
    _t(
      translations.Image_size_exceeds_the_10MB_limit_Please_use_a_smaller_image,
    ),
  Unable_to_fetch_image_from_URL_Try_downloading_and_uploading_locally: () =>
    _t(
      translations.Unable_to_fetch_image_from_URL_Try_downloading_and_uploading_locally,
    ),
  FlyerItem: () => _t(translations.FlyerItem),
  Promotion: () => _t(translations.Promotion),
  Product: () => _t(translations.Product),
  FigmaTemplate: () => _t(translations.FigmaTemplate),
  Edit_Figma_Template: () => _t(translations.Edit_Figma_Template),
  Create_Figma_Template: () => _t(translations.Create_Figma_Template),
  Update_Your_Figma_Template_Configuration: () =>
    _t(translations.Update_Your_Figma_Template_Configuration),
  Set_Up_A_New_Figma_Template_For_Your_Designs: () =>
    _t(translations.Set_Up_A_New_Figma_Template_For_Your_Designs),
  Editing: () => _t(translations.Editing),
  New: () => _t(translations.New),
  Please_Fix_The_Errors_Below_Before_Saving: () =>
    _t(translations.Please_Fix_The_Errors_Below_Before_Saving),
  Loading_Template_Data: () => _t(translations.Loading_Template_Data),
  Basic_Information: () => _t(translations.Basic_Information),
  Essential_Details_About_Your_Template: () =>
    _t(translations.Essential_Details_About_Your_Template),
  Template_Name: () => _t(translations.Template_Name),
  Enter_A_Descriptive_Name_For_Your_Template: () =>
    _t(translations.Enter_A_Descriptive_Name_For_Your_Template),
  Template_Tag: () => _t(translations.Template_Tag),
  No_Tag_Selected: () => _t(translations.No_Tag_Selected),
  Number_Of_Pages: () => _t(translations.Number_Of_Pages),
  How_Many_Pages_Does_This_Template_Contain: () =>
    _t(translations.How_Many_Pages_Does_This_Template_Contain),
  Example_2: () => _t(translations.Example_2),
  Categories: () => _t(translations.Categories),
  Classify_Your_Template_By_Relevant_Categories: () =>
    _t(translations.Classify_Your_Template_By_Relevant_Categories),
  Required: () => _t(translations.Required),
  Template_Visibility: () => _t(translations.Template_Visibility),
  Define_Who_Can_Access_This_Template: () =>
    _t(translations.Define_Who_Can_Access_This_Template),
  Visibility_Type: () => _t(translations.Visibility_Type),
  Choose_Whether_This_Template_Is_Public_Or_Store_Specific: () =>
    _t(translations.Choose_Whether_This_Template_Is_Public_Or_Store_Specific),
  Select_Visibility_Type: () => _t(translations.Select_Visibility_Type),
  Public: () => _t(translations.Public),
  Specific: () => _t(translations.Specific),
  Select_Specific_Stores: () => _t(translations.Select_Specific_Stores),
  Figma_File: () => _t(translations.Figma_File),
  Upload_Or_Link_To_Your_Figma_Template_File: () =>
    _t(translations.Upload_Or_Link_To_Your_Figma_Template_File),
  Optional: () => _t(translations.Optional),
  Ready_To_Save: () => _t(translations.Ready_To_Save),
  Please_Fix_Errors_Before_Saving: () =>
    _t(translations.Please_Fix_Errors_Before_Saving),
  Saving: () => _t(translations.Saving),
  Update_Template: () => _t(translations.Update_Template),
  Create_Template: () => _t(translations.Create_Template),
  Updating_Template: () => _t(translations.Updating_Template),
  Creating_Template: () => _t(translations.Creating_Template),
  E_G_2: () => _t(translations.E_G_2),
  File_Size_Exceeds_2Gb_Limit: () =>
    _t(translations.File_Size_Exceeds_2Gb_Limit),
  File_Type_Not_Supported: () => _t(translations.File_Type_Not_Supported),
  Authentication_Required: () => _t(translations.Authentication_Required),
  Upload_Failed: () => _t(translations.Upload_Failed),
  Drop_To_Replace_File: () => _t(translations.Drop_To_Replace_File),
  Uploaded_File: () => _t(translations.Uploaded_File),
  Processing: () => _t(translations.Processing),
  Upload_Complete: () => _t(translations.Upload_Complete),
  Uploading_File: () => _t(translations.Uploading_File),
  Replace_File: () => _t(translations.Replace_File),
  Drop_Your_File_Here: () => _t(translations.Drop_Your_File_Here),
  Drop_Your_Figma_File_Here: () => _t(translations.Drop_Your_Figma_File_Here),
  Release_To_Upload_Your_File: () =>
    _t(translations.Release_To_Upload_Your_File),
  Optional_Drag_And_Drop_Or_Click_To_Select: () =>
    _t(translations.Optional_Drag_And_Drop_Or_Click_To_Select),
  Drop_Here: () => _t(translations.Drop_Here),
  Select_File: () => _t(translations.Select_File),
  Maximum_File_Size_2Gb: () => _t(translations.Maximum_File_Size_2Gb),
  File_Uploaded_Successfully_S3_Url_Generated: () =>
    _t(translations.File_Uploaded_Successfully_S3_Url_Generated),
  Preview_Image: () => _t(translations.Preview_Image),
  Upload_Template_Image: () => _t(translations.Upload_Template_Image),
  Optional_Info: () => _t(translations.Optional_Info),
  Uploading_Status: () => _t(translations.Uploading_Status),
  Drop_Your_Image_Here: () => _t(translations.Drop_Your_Image_Here),
  Template_Preview: () => _t(translations.Template_Preview),
  Template_Preview_Image_Upload: () =>
    _t(translations.Template_Preview_Image_Upload),
  Template_Preview_Enlarged: () => _t(translations.Template_Preview_Enlarged),
  Upload_an_image_that_represents_your_template: () =>
    _t(translations.Upload_an_image_that_represents_your_template),
  Figma_Templates: () => _t(translations.Figma_Templates),
  Figma_Template_Tag: () => _t(translations.Figma_Template_Tag),
  Required_Field: () => _t(translations.Required_Field),
  Edit_Template: () => _t(translations.Edit_Template),
  Choose_Figma_Template_For_Component_Position: () =>
    _t(translations.Choose_Figma_Template_For_Component_Position),
  templateDetailsTitle: () => _t(translations.templateDetailsTitle),
  viewTemplateButton: () => _t(translations.viewTemplateButton),
  imagePreviewTitle: () => _t(translations.imagePreviewTitle),
  imagePreviewTipsLabel: () => _t(translations.imagePreviewTipsLabel),
  imagePreviewTipMouseWheel: () => _t(translations.imagePreviewTipMouseWheel),
  imagePreviewTipDrag: () => _t(translations.imagePreviewTipDrag),
  imagePreviewTipToggle: () => _t(translations.imagePreviewTipToggle),
  imagePreviewTipPinch: () => _t(translations.imagePreviewTipPinch),
  noImageLabel: () => _t(translations.noImageLabel),
  downloadWarningMessage: () => _t(translations.downloadWarningMessage),
  templateSelectionTitle: () => _t(translations.templateSelectionTitle),
  loadingTemplates: () => _t(translations.loadingTemplates),
  noTemplatesAvailable: () => _t(translations.noTemplatesAvailable),
  noTemplatesAvailableDescription: () =>
    _t(translations.noTemplatesAvailableDescription),
  unselectButton: () => _t(translations.unselectButton),
  generateButton: () => _t(translations.generateButton),
  generatingStatus: () => _t(translations.generatingStatus),
  openOriginalTooltip: () => _t(translations.openOriginalTooltip),
  NoPreview: () => _t(translations.NoPreview),
  Open_in_New_Tab: () => _t(translations.Open_in_New_Tab),
  Translate: () => _t(translations.Translate),
  Triggered_By: () => _t(translations.Triggered_By),
  Test_Layout: () => _t(translations.Test_Layout),
  Check_Status: () => _t(translations.Check_Status),
  Confirm_Template_Layout_Test: () =>
    _t(translations.Confirm_Template_Layout_Test),
  Are_You_Sure_You_Want_To_Trigger_Template_Layout_Test: () =>
    _t(translations.Are_You_Sure_You_Want_To_Trigger_Template_Layout_Test),
  Template_Layout_Test_Triggered: () =>
    _t(translations.Template_Layout_Test_Triggered),
  Configuration_Management: () => _t(translations.Configuration_Management),
  Advanced_Search_Configuration: () =>
    _t(translations.Advanced_Search_Configuration),
  Reset_to_Defaults: () => _t(translations.Reset_to_Defaults),
  Enable_Advanced_Search_Configuration: () =>
    _t(translations.Enable_Advanced_Search_Configuration),
  Changes_Saved_on_Apply: () => _t(translations.Changes_Saved_on_Apply),
  Search_Behavior_Settings: () => _t(translations.Search_Behavior_Settings),
  Keep_Search_Results_When_Creating_Flyer_Item: () =>
    _t(translations.Keep_Search_Results_When_Creating_Flyer_Item),
  Search_Results_Visibility_Tooltip: () =>
    _t(translations.Search_Results_Visibility_Tooltip),
  Search_Result_Limit: () => _t(translations.Search_Result_Limit),
  Search_Result_Limit_Helper: () => _t(translations.Search_Result_Limit_Helper),
  Search_In_Flyer_Item_Names: () => _t(translations.Search_In_Flyer_Item_Names),
  Search_In_Flyer_Item_Names_Tooltip: () =>
    _t(translations.Search_In_Flyer_Item_Names_Tooltip),
  Fix_Validation_Errors_To_Apply_Settings: () =>
    _t(translations.Fix_Validation_Errors_To_Apply_Settings),
  Apply_Settings: () => _t(translations.Apply_Settings),
  Successfully_Updated: () => _t(translations.Successfully_Updated),
  Image_Tag: () => _t(translations.Image_Tag),
  ImageTag: () => _t(translations.ImageTag),
  Batch_Update_Tags: () => _t(translations.Batch_Update_Tags),
  Description: () => _t(translations.Description),
  Editing_User: () => _t(translations.Editing_User),
  Admin_User_Settings: () => _t(translations.Admin_User_Settings),
  Manage_your_personal_settings: () =>
    _t(translations.Manage_your_personal_settings),
  Total_Settings: () => _t(translations.Total_Settings),
  Current_Page: () => _t(translations.Current_Page),
  Showing_Items: () => _t(translations.Showing_Items),
  Search_settings: () => _t(translations.Search_settings),
  Search_by_setting_key: () => _t(translations.Search_by_setting_key),
  All_Categories: () => _t(translations.All_Categories),
  No_settings_found: () => _t(translations.No_settings_found),
  Click_Add_Setting_to_create_your_first_setting: () =>
    _t(translations.Click_Add_Setting_to_create_your_first_setting),
  Admin_Settings_Catalog: () => _t(translations.Admin_Settings_Catalog),
  RecommendationEngine_Title: () => _t(translations.RecommendationEngine_Title),
  Analytics_Title: () => _t(translations.Analytics_Title),
  Analytics_TotalViews: () => _t(translations.Analytics_TotalViews),
  Analytics_TotalClicks: () => _t(translations.Analytics_TotalClicks),
  Analytics_TotalSaves: () => _t(translations.Analytics_TotalSaves),
  Analytics_AvgCTR: () => _t(translations.Analytics_AvgCTR),
  Analytics_HotDeals: () => _t(translations.Analytics_HotDeals),
  Analytics_DepartmentEngagement: () =>
    _t(translations.Analytics_DepartmentEngagement),
  Analytics_TopPerformingDeals: () =>
    _t(translations.Analytics_TopPerformingDeals),
  Analytics_Unavailable: () => _t(translations.Analytics_Unavailable),
  Analytics_FilterOutOfScope: () => _t(translations.Analytics_FilterOutOfScope),
  Analytics_NoData: () => _t(translations.Analytics_NoData),
  Analytics_Subtitle: () => _t(translations.Analytics_Subtitle),
  Analytics_Insights: () => _t(translations.Analytics_Insights),
  Analytics_PerformanceOverview: () =>
    _t(translations.Analytics_PerformanceOverview),
  Reset: () => _t(translations.Reset),
  All_global_setting_definitions: () =>
    _t(translations.All_global_setting_definitions),
  Available_Settings: () => _t(translations.Available_Settings),
  My_Settings: () => _t(translations.My_Settings),
  Configure: () => _t(translations.Configure),
  Reset_To_Default: () => _t(translations.Reset_To_Default),
  Effective_Value: () => _t(translations.Effective_Value),
  Default_Value: () => _t(translations.Default_Value),
  Overridden: () => _t(translations.Overridden),
  My_Settings_subtitle: () => _t(translations.My_Settings_subtitle),
  Available_Settings_subtitle: () =>
    _t(translations.Available_Settings_subtitle),
  No_overridden_settings_yet: () => _t(translations.No_overridden_settings_yet),
  Flyer_Review: () => _t(translations.Flyer_Review),
  Adjust: () => _t(translations.Adjust),
  Who_Has_Access: () => _t(translations.Who_Has_Access),
  Share: () => _t(translations.Share),
  Approve: () => _t(translations.Approve),
  Reopen: () => _t(translations.Reopen),
  Restore_Permissions: () => _t(translations.Restore_Permissions),
  Anyone_With_Link: () => _t(translations.Anyone_With_Link),
  Audience_Key: () => _t(translations.Audience_Key),
  Display_Name: () => _t(translations.Display_Name),
  Expires_At: () => _t(translations.Expires_At),
  Regenerate_Link: () => _t(translations.Regenerate_Link),
  Revoke: () => _t(translations.Revoke),
  Copy_Link: () => _t(translations.Copy_Link),
  Copied: () => _t(translations.Copied),
  Change_Requests: () => _t(translations.Change_Requests),
  Comments: () => _t(translations.Comments),
  View_History: () => _t(translations.View_History),
  Accept: () => _t(translations.Accept),
  Reject: () => _t(translations.Reject),
  Restore: () => _t(translations.Restore),
  Restore_EDIT_Permissions_Prompt: () =>
    _t(translations.Restore_EDIT_Permissions_Prompt),
  Reviewers_Moved_To_View_Only: () =>
    _t(translations.Reviewers_Moved_To_View_Only),
  Bulk_Accept: () => _t(translations.Bulk_Accept),
  Publish_Date: () => _t(translations.Publish_Date),
  Invite_Reviewer: () => _t(translations.Invite_Reviewer),
  No_Audiences_Yet: () => _t(translations.No_Audiences_Yet),
  No_Change_Requests_Yet: () => _t(translations.No_Change_Requests_Yet),
  No_Comments_Yet: () => _t(translations.No_Comments_Yet),
  Change_Request_History: () => _t(translations.Change_Request_History),
  Applied_Revision: () => _t(translations.Applied_Revision),
  Before: () => _t(translations.Before),
  After: () => _t(translations.After),
  Export_Change_Report: () => _t(translations.Export_Change_Report),
  Audience_Key_Already_Taken: () => _t(translations.Audience_Key_Already_Taken),
  Edit_Permission_Required: () => _t(translations.Edit_Permission_Required),
  Field_Not_Yet_Supported: () => _t(translations.Field_Not_Yet_Supported),
  Flyer_Already_Approved: () => _t(translations.Flyer_Already_Approved),
  Token_Expired: () => _t(translations.Token_Expired),
  Token_Revoked: () => _t(translations.Token_Revoked),
  Audience_Revoked: () => _t(translations.Audience_Revoked),
  Session_Closed: () => _t(translations.Session_Closed),
  Field_Key: () => _t(translations.Field_Key),
  Submitted_At: () => _t(translations.Submitted_At),
  Submitted_By: () => _t(translations.Submitted_By),
  Restored: () => _t(translations.Restored),
  Live: () => _t(translations.Live),
  Offline: () => _t(translations.Offline),
  Viewing: () => _t(translations.Viewing),
  Comments_All: () => _t(translations.Comments_All),
  Comments_Open: () => _t(translations.Comments_Open),
  Comments_Resolved: () => _t(translations.Comments_Resolved),
  Search_Comments: () => _t(translations.Search_Comments),
  Comment_On_Field: () => _t(translations.Comment_On_Field),
  Comment_On_Flyer_Item: () => _t(translations.Comment_On_Flyer_Item),
  Comment_On_Flyer: () => _t(translations.Comment_On_Flyer),
  Resolved_By: () => _t(translations.Resolved_By),
  Show_N_More_Replies: () => _t(translations.Show_N_More_Replies),
  Admin: () => _t(translations.Admin),
  Reviewer: () => _t(translations.Reviewer),
  Unknown: () => _t(translations.Unknown),
  No_Open_Comments: () => _t(translations.No_Open_Comments),
  No_Resolved_Comments: () => _t(translations.No_Resolved_Comments),
  No_Comments_Match_Search: () => _t(translations.No_Comments_Match_Search),
  Changes_By_Item: () => _t(translations.Changes_By_Item),
  Flyer_Comments: () => _t(translations.Flyer_Comments),
  Changes_Count: () => _t(translations.Changes_Count),
  Comments_Count: () => _t(translations.Comments_Count),
  Pending_Count: () => _t(translations.Pending_Count),
  Accepted_Count: () => _t(translations.Accepted_Count),
  Rejected_Count: () => _t(translations.Rejected_Count),
  Open_Comment_Count: () => _t(translations.Open_Comment_Count),
  Item_Rank: () => _t(translations.Item_Rank),
  Unnamed_Item: () => _t(translations.Unnamed_Item),
  No_Items_With_Changes_Yet: () => _t(translations.No_Items_With_Changes_Yet),
  No_Flyer_Level_Comments: () => _t(translations.No_Flyer_Level_Comments),
  Review_More_Actions: () => _t(translations.Review_More_Actions),
  Review_Load_Flyer_Error: () => _t(translations.Review_Load_Flyer_Error),
  Review_Retry_Load_Flyer: () => _t(translations.Review_Retry_Load_Flyer),
  Review_Copy_Flyer_Id: () => _t(translations.Review_Copy_Flyer_Id),
  Review_Flyer_Context: () => _t(translations.Review_Flyer_Context),
  Open_In_Flyer_Editor: () => _t(translations.Open_In_Flyer_Editor),
  Open_In_Item_Editor: () => _t(translations.Open_In_Item_Editor),
  Review_Session_Label: () => _t(translations.Review_Session_Label),
  Review_Anyone_Link: () => _t(translations.Review_Anyone_Link),
  Review_Active_Audiences: () => _t(translations.Review_Active_Audiences),
  Review_Workspace_Pending: () => _t(translations.Review_Workspace_Pending),
  Review_Workspace_Items: () => _t(translations.Review_Workspace_Items),
  Review_Workspace_Flyer_Comments: () =>
    _t(translations.Review_Workspace_Flyer_Comments),
  Review_Session_Status_Active: () =>
    _t(translations.Review_Session_Status_Active),
  Review_Session_Status_Approved: () =>
    _t(translations.Review_Session_Status_Approved),
  Review_Session_Status_Closed: () =>
    _t(translations.Review_Session_Status_Closed),
  Review_Select_Item_Hint: () => _t(translations.Review_Select_Item_Hint),
  Review_Workbench_Subtitle: () => _t(translations.Review_Workbench_Subtitle),
  Review_Item_Inspector_Hint: () => _t(translations.Review_Item_Inspector_Hint),
  Review_Item_List: () => _t(translations.Review_Item_List),
  Review_Item_Details: () => _t(translations.Review_Item_Details),
  Tab_Items: () => _t(translations.Tab_Items),
  Tab_Work: () => _t(translations.Tab_Work),
  Tab_Details: () => _t(translations.Tab_Details),
  Review_Approved_At: () => _t(translations.Review_Approved_At),
  History: () => _t(translations.History),
  Reverted: () => _t(translations.Reverted),
  View_Full_History: () => _t(translations.View_Full_History),
  Full_Change_History: () => _t(translations.Full_Change_History),
  Reverts_Earlier_Change: () => _t(translations.Reverts_Earlier_Change),
  Reverted_By_Later_Change: () => _t(translations.Reverted_By_Later_Change),
  Cannot_Restore_Manual_Signal: () =>
    _t(translations.Cannot_Restore_Manual_Signal),
  Review_Manual_Cr_Notice_Title: () =>
    _t(translations.Review_Manual_Cr_Notice_Title),
  Review_Manual_Cr_Notice_Body: () =>
    _t(translations.Review_Manual_Cr_Notice_Body),
  Review_Manual_Cr_Step_Apply: () =>
    _t(translations.Review_Manual_Cr_Step_Apply),
  Review_Manual_Cr_Step_Accept: () =>
    _t(translations.Review_Manual_Cr_Step_Accept),
  Review_Manual_Cr_Accept_Help: () =>
    _t(translations.Review_Manual_Cr_Accept_Help),
  Review_Manual_Cr_Requested_Change: () =>
    _t(translations.Review_Manual_Cr_Requested_Change),
  Review_Manual_Cr_Field_Image: () =>
    _t(translations.Review_Manual_Cr_Field_Image),
  Review_Manual_Cr_Field_Swap_Position: () =>
    _t(translations.Review_Manual_Cr_Field_Swap_Position),
  Review_Manual_Cr_Field_Delete_Item: () =>
    _t(translations.Review_Manual_Cr_Field_Delete_Item),
  Review_Manual_Cr_Delete_Reason: () =>
    _t(translations.Review_Manual_Cr_Delete_Reason),
  Review_Manual_Cr_Swap_Partner: () =>
    _t(translations.Review_Manual_Cr_Swap_Partner),
  Review_Manual_Cr_Swap_With: () => _t(translations.Review_Manual_Cr_Swap_With),
  Review_Manual_Cr_Swap_Item_Unavailable: () =>
    _t(translations.Review_Manual_Cr_Swap_Item_Unavailable),
  Review_Manual_Cr_Image_Hint: () =>
    _t(translations.Review_Manual_Cr_Image_Hint),
  Cannot_Restore_Already_Reverted: () =>
    _t(translations.Cannot_Restore_Already_Reverted),
  Cannot_Restore_Not_Accepted: () =>
    _t(translations.Cannot_Restore_Not_Accepted),
  Cannot_Restore_Flyer_Approved: () =>
    _t(translations.Cannot_Restore_Flyer_Approved),
  Cannot_Restore_No_Before_Value: () =>
    _t(translations.Cannot_Restore_No_Before_Value),
  Restore_Eligibility_Help: () => _t(translations.Restore_Eligibility_Help),
  Anonymous_Reviewer: () => _t(translations.Anonymous_Reviewer),
  Restored_By_Admin: () => _t(translations.Restored_By_Admin),
  Restored_At: () => _t(translations.Restored_At),
  Restore_Source_CR: () => _t(translations.Restore_Source_CR),
  Revert_CR: () => _t(translations.Revert_CR),
  History_Empty_Title: () => _t(translations.History_Empty_Title),
  History_Empty_Subtitle: () => _t(translations.History_Empty_Subtitle),
  History_Slot_Header_Field: () => _t(translations.History_Slot_Header_Field),
  History_Slot_Restore_Hint: () => _t(translations.History_Slot_Restore_Hint),
  Cr_Status_Pending: () => _t(translations.Cr_Status_Pending),
  Cr_Status_Accepted: () => _t(translations.Cr_Status_Accepted),
  Cr_Status_Rejected: () => _t(translations.Cr_Status_Rejected),
  Cr_Status_Superseded: () => _t(translations.Cr_Status_Superseded),
  Cr_Status_Restored: () => _t(translations.Cr_Status_Restored),
  Filter_op_contains: () => _t(translations.Filter_op_contains),
  Filter_op_equals: () => _t(translations.Filter_op_equals),
  Filter_op_startsWith: () => _t(translations.Filter_op_startsWith),
  Filter_op_endsWith: () => _t(translations.Filter_op_endsWith),
  Filter_op_isEmpty: () => _t(translations.Filter_op_isEmpty),
  Filter_op_isNotEmpty: () => _t(translations.Filter_op_isNotEmpty),
  Filter_op_eq: () => _t(translations.Filter_op_eq),
  Filter_op_ne: () => _t(translations.Filter_op_ne),
  Filter_op_gt: () => _t(translations.Filter_op_gt),
  Filter_op_gte: () => _t(translations.Filter_op_gte),
  Filter_op_lt: () => _t(translations.Filter_op_lt),
  Filter_op_lte: () => _t(translations.Filter_op_lte),
  Filter_op_is: () => _t(translations.Filter_op_is),
  Filter_op_not: () => _t(translations.Filter_op_not),
  Filter_op_after: () => _t(translations.Filter_op_after),
  Filter_op_onOrAfter: () => _t(translations.Filter_op_onOrAfter),
  Filter_op_before: () => _t(translations.Filter_op_before),
  Filter_op_onOrBefore: () => _t(translations.Filter_op_onOrBefore),
  Filter_value_placeholder: () => _t(translations.Filter_value_placeholder),
  Filter_search_placeholder: () => _t(translations.Filter_search_placeholder),
  Filter_bool_true: () => _t(translations.Filter_bool_true),
  Filter_bool_false: () => _t(translations.Filter_bool_false),
  Filter_any: () => _t(translations.Filter_any),
  Filter_no_value: () => _t(translations.Filter_no_value),
  Filter_clear: () => _t(translations.Filter_clear),
  Filter_change_operator: () => _t(translations.Filter_change_operator),
  Filter_operator_label: () => _t(translations.Filter_operator_label),
  Filter_active_title: () => _t(translations.Filter_active_title),
  Filter_clear_all: () => _t(translations.Filter_clear_all),
  Filter_remove: () => _t(translations.Filter_remove),
  form_required_hint: () => _t(translations.form_required_hint),
  preference_cuisine: () => _t(translations.preference_cuisine),
  preference_cuisines: () => _t(translations.preference_cuisines),
  preference_section_labels: () => _t(translations.preference_section_labels),
  preference_section_categories: () =>
    _t(translations.preference_section_categories),
  preference_cuisine_name: () => _t(translations.preference_cuisine_name),
  preference_cuisine_name_helper: () =>
    _t(translations.preference_cuisine_name_helper),
  preference_cuisine_name_chinese: () =>
    _t(translations.preference_cuisine_name_chinese),
  preference_cuisine_name_french: () =>
    _t(translations.preference_cuisine_name_french),
  preference_cuisine_index: () => _t(translations.preference_cuisine_index),
  preference_cuisine_index_helper: () =>
    _t(translations.preference_cuisine_index_helper),
  preference_cuisine_slug: () => _t(translations.preference_cuisine_slug),
  preference_cuisine_categories: () =>
    _t(translations.preference_cuisine_categories),
  preference_cuisine_search: () => _t(translations.preference_cuisine_search),
  preference_cuisine_categories_helper: () =>
    _t(translations.preference_cuisine_categories_helper),
  preference_cuisine_name_required: () =>
    _t(translations.preference_cuisine_name_required),
  preference_cuisine_index_invalid: () =>
    _t(translations.preference_cuisine_index_invalid),
  preference_cuisine_create_success: () =>
    _t(translations.preference_cuisine_create_success),
  preference_cuisine_update_success: () =>
    _t(translations.preference_cuisine_update_success),
  preference_tip_cuisine_name: () =>
    _t(translations.preference_tip_cuisine_name),
  preference_tip_locale_label: () =>
    _t(translations.preference_tip_locale_label),
  preference_tip_cuisine_index: () =>
    _t(translations.preference_tip_cuisine_index),
  preference_tip_cuisine_categories: () =>
    _t(translations.preference_tip_cuisine_categories),
  preference_slug_tooltip: () => _t(translations.preference_slug_tooltip),
  preference_delete_slug_warning: () =>
    _t(translations.preference_delete_slug_warning),
  preference_translate_from_english: () =>
    _t(translations.preference_translate_from_english),
  preference_translate_no_source: () =>
    _t(translations.preference_translate_no_source),
  preference_translate_all: () => _t(translations.preference_translate_all),
  preference_translate_all_tooltip: () =>
    _t(translations.preference_translate_all_tooltip),
  preference_translate_nothing_to_do: () =>
    _t(translations.preference_translate_nothing_to_do),
  preference_translate_filled: () =>
    _t(translations.preference_translate_filled),
  preference_category_offered: () =>
    _t(translations.preference_category_offered),
  preference_category_offered_tooltip: () =>
    _t(translations.preference_category_offered_tooltip),
  preference_watch_item: () => _t(translations.preference_watch_item),
  preference_watch_items: () => _t(translations.preference_watch_items),
  preference_section_watch_item: () =>
    _t(translations.preference_section_watch_item),
  preference_watch_item_normalized: () =>
    _t(translations.preference_watch_item_normalized),
  preference_watch_item_normalized_helper: () =>
    _t(translations.preference_watch_item_normalized_helper),
  preference_watch_item_search: () =>
    _t(translations.preference_watch_item_search),
  preference_watch_item_create_success: () =>
    _t(translations.preference_watch_item_create_success),
  preference_watch_item_update_success: () =>
    _t(translations.preference_watch_item_update_success),
  preference_watch_item_name: () => _t(translations.preference_watch_item_name),
  preference_watch_item_name_helper: () =>
    _t(translations.preference_watch_item_name_helper),
  preference_watch_item_name_required: () =>
    _t(translations.preference_watch_item_name_required),
  preference_tip_watch_item_name: () =>
    _t(translations.preference_tip_watch_item_name),
  preference_watch_item_curated: () =>
    _t(translations.preference_watch_item_curated),
  preference_watch_item_curated_helper: () =>
    _t(translations.preference_watch_item_curated_helper),
  preference_watch_item_curated_yes: () =>
    _t(translations.preference_watch_item_curated_yes),
  preference_watch_item_curated_no: () =>
    _t(translations.preference_watch_item_curated_no),
  preference_watch_item_intro: () =>
    _t(translations.preference_watch_item_intro),
  WEBSITE_FLYER_DISPLAY: () => _t(translations.WEBSITE_FLYER_DISPLAY),
  Website_Flyer_Display_Enabled: () =>
    _t(translations.Website_Flyer_Display_Enabled),
  Website_Flyer_Display_Enabled_Tooltip: () =>
    _t(translations.Website_Flyer_Display_Enabled_Tooltip),
  Website_Flyer_Latest_Only: () => _t(translations.Website_Flyer_Latest_Only),
  Website_Flyer_Latest_Only_Tooltip: () =>
    _t(translations.Website_Flyer_Latest_Only_Tooltip),
  Website_Flyer_Release_Day_Time: () =>
    _t(translations.Website_Flyer_Release_Day_Time),
  Website_Flyer_Release_Day_Time_Tooltip: () =>
    _t(translations.Website_Flyer_Release_Day_Time_Tooltip),
  Release_Day: () => _t(translations.Release_Day),
  Release_Time: () => _t(translations.Release_Time),
  Clear_Release_Schedule: () => _t(translations.Clear_Release_Schedule),
  No_Schedule: () => _t(translations.No_Schedule),
  Release_Day_And_Time_Both_Required: () =>
    _t(translations.Release_Day_And_Time_Both_Required),
  Session_Expired_Title: () => _t(translations.Session_Expired_Title),
  Session_Expired_Description: () =>
    _t(translations.Session_Expired_Description),
  Session_Expired_Identifier_Label: () =>
    _t(translations.Session_Expired_Identifier_Label),
  Session_Expired_Google: () => _t(translations.Session_Expired_Google),
  Session_Expired_Sign_Out: () => _t(translations.Session_Expired_Sign_Out),
  Session_Expired_Sign_Out_Anyway: () =>
    _t(translations.Session_Expired_Sign_Out_Anyway),
  Session_Expired_Unsaved_Warning: () =>
    _t(translations.Session_Expired_Unsaved_Warning),
  Session_Expired_Different_Account: () =>
    _t(translations.Session_Expired_Different_Account),
  Session_Expired_Fields_Required: () =>
    _t(translations.Session_Expired_Fields_Required),
  Session_Expired_Sign_In_Failed: () =>
    _t(translations.Session_Expired_Sign_In_Failed),
  List_Load_Failed: () => _t(translations.List_Load_Failed),
  All_Flyer_Items_Load_Failed: () =>
    _t(translations.All_Flyer_Items_Load_Failed),
  Try_Again: () => _t(translations.Try_Again),
  Deal_Spotlights: () => _t(translations.Deal_Spotlights),
  Spotlights_Are_Buttons_On_All_Deals_And_The_Deals_Home_Page: () =>
    _t(
      translations.Spotlights_Are_Buttons_On_All_Deals_And_The_Deals_Home_Page,
    ),
  Add_Spotlight: () => _t(translations.Add_Spotlight),
  Spotlight_Deleted: () => _t(translations.Spotlight_Deleted),
  Delete_Spotlight: () => _t(translations.Delete_Spotlight),
  Delete_Name_And_Its_Formula: () =>
    _t(translations.Delete_Name_And_Its_Formula),
  On_Site: () => _t(translations.On_Site),
  Loading_Spotlights: () => _t(translations.Loading_Spotlights),
  No_Spotlights_Yet: () => _t(translations.No_Spotlights_Yet),
  Text_Only_Button: () => _t(translations.Text_Only_Button),
  No_Image_The_Site_Shows_A_Text_Only_Button: () =>
    _t(translations.No_Image_The_Site_Shows_A_Text_Only_Button),
  Show_Name_On_The_Site: () => _t(translations.Show_Name_On_The_Site),
  Edit_Name: () => _t(translations.Edit_Name),
  Delete_Name: () => _t(translations.Delete_Name),
  New_Spotlight: () => _t(translations.New_Spotlight),
  Edit_Spotlight: () => _t(translations.Edit_Spotlight),
  Back_To_Deal_Spotlights: () => _t(translations.Back_To_Deal_Spotlights),
  Info: () => _t(translations.Info),
  Formula: () => _t(translations.Formula),
  Reason_For_This_Change: () => _t(translations.Reason_For_This_Change),
  Saved_With_Formula_Changes: () => _t(translations.Saved_With_Formula_Changes),
  Updating: () => _t(translations.Updating),
  Create_Spotlight: () => _t(translations.Create_Spotlight),
  Creating: () => _t(translations.Creating),
  Spotlight_Updated: () => _t(translations.Spotlight_Updated),
  Spotlight_Created: () => _t(translations.Spotlight_Created),
  Loaded_The_Latest_Formula: () => _t(translations.Loaded_The_Latest_Formula),
  Formula_Reset_To_The_Default: () =>
    _t(translations.Formula_Reset_To_The_Default),
  Reset_Formula_To_Default: () => _t(translations.Reset_Formula_To_Default),
  The_Default_Formula_Replaces_This_One_Straight_Away: () =>
    _t(translations.The_Default_Formula_Replaces_This_One_Straight_Away),
  Your_Unsaved_Formula_Changes_Are_Lost: () =>
    _t(translations.Your_Unsaved_Formula_Changes_Are_Lost),
  Discard_Changes: () => _t(translations.Discard_Changes),
  Your_Changes_To_This_Spotlight_Are_Not_Saved: () =>
    _t(translations.Your_Changes_To_This_Spotlight_Are_Not_Saved),
  Names: () => _t(translations.Names),
  Display: () => _t(translations.Display),
  Name_English: () => _t(translations.Name_English),
  Name_Chinese: () => _t(translations.Name_Chinese),
  Name_French: () => _t(translations.Name_French),
  Top_Pick_Deals: () => _t(translations.Top_Pick_Deals),
  Falls_Back_To_The_English_Name: () =>
    _t(translations.Falls_Back_To_The_English_Name),
  GIFs_Stay_Animated_Without_An_Image_The_Button_Shows_Text_Only: () =>
    _t(
      translations.GIFs_Stay_Animated_Without_An_Image_The_Button_Shows_Text_Only,
    ),
  Drop_An_Image_Here_Or_Click_To_Upload: () =>
    _t(translations.Drop_An_Image_Here_Or_Click_To_Upload),
  Drop_To_Upload: () => _t(translations.Drop_To_Upload),
  Upload_An_Image: () => _t(translations.Upload_An_Image),
  Replace_The_Image: () => _t(translations.Replace_The_Image),
  Name_Image: () => _t(translations.Name_Image),
  Replace: () => _t(translations.Replace),
  Lower_Numbers_Show_First: () => _t(translations.Lower_Numbers_Show_First),
  On_The_Site: () => _t(translations.On_The_Site),
  Shown_On_The_Site: () => _t(translations.Shown_On_The_Site),
  Hidden_On_The_Site: () => _t(translations.Hidden_On_The_Site),
  Recommendation_Engine_Formula: () =>
    _t(translations.Recommendation_Engine_Formula),
  Unsaved_Formula_Changes: () => _t(translations.Unsaved_Formula_Changes),
  Only_A_Super_Admin_Can_Change_The_Formula: () =>
    _t(translations.Only_A_Super_Admin_Can_Change_The_Formula),
  Promotion_Tags: () => _t(translations.Promotion_Tags),
  Deals_Carrying_Any_Of_These_Tags_Are_Added: () =>
    _t(translations.Deals_Carrying_Any_Of_These_Tags_Are_Added),
  Search_Promotion_Tags: () => _t(translations.Search_Promotion_Tags),
  Unknown_Tag_Id: () => _t(translations.Unknown_Tag_Id),
  Preview_Spotlight_Formula: () => _t(translations.Preview_Spotlight_Formula),
  Runs_The_Formula_As_Edited_Without_Saving_It: () =>
    _t(translations.Runs_The_Formula_As_Edited_Without_Saving_It),
  Customer_Id: () => _t(translations.Customer_Id),
  Run: () => _t(translations.Run),
  The_Formula_Finds_No_Deals_Here: () =>
    _t(translations.The_Formula_Finds_No_Deals_Here),
  Run_The_Preview_To_See_The_Deals_This_Formula_Ranks_First: () =>
    _t(translations.Run_The_Preview_To_See_The_Deals_This_Formula_Ranks_First),
  Leave_Empty_To_Keep_Current: () =>
    _t(translations.Leave_Empty_To_Keep_Current),
};
